/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages


        /**
         * bxSlider v4.2.12
         * Copyright 2013-2015 Steven Wanderski
         * Written while drinking Belgian ales and listening to jazz
         * Licensed under MIT (http://opensource.org/licenses/MIT)
         */
        !function(t){var e={mode:"horizontal",slideSelector:"",infiniteLoop:!0,hideControlOnEnd:!1,speed:500,easing:null,slideMargin:0,startSlide:0,randomStart:!1,captions:!1,ticker:!1,tickerHover:!1,adaptiveHeight:!1,adaptiveHeightSpeed:500,video:!1,useCSS:!0,preloadImages:"visible",responsive:!0,slideZIndex:50,wrapperClass:"bx-wrapper",touchEnabled:!0,swipeThreshold:50,oneToOneTouch:!0,preventDefaultSwipeX:!0,preventDefaultSwipeY:!1,ariaLive:!0,ariaHidden:!0,keyboardEnabled:!1,pager:!0,pagerType:"full",pagerShortSeparator:" / ",pagerSelector:null,buildPager:null,pagerCustom:null,controls:!0,nextText:"Next",prevText:"Prev",nextSelector:null,prevSelector:null,autoControls:!1,startText:"Start",stopText:"Stop",autoControlsCombine:!1,autoControlsSelector:null,auto:!1,pause:4e3,autoStart:!0,autoDirection:"next",stopAutoOnClick:!1,autoHover:!1,autoDelay:0,autoSlideForOnePage:!1,minSlides:1,maxSlides:1,moveSlides:0,slideWidth:0,shrinkItems:!1,onSliderLoad:function(){return!0},onSlideBefore:function(){return!0},onSlideAfter:function(){return!0},onSlideNext:function(){return!0},onSlidePrev:function(){return!0},onSliderResize:function(){return!0},onAutoChange:function(){return!0}};t.fn.bxSlider=function(n){if(0===this.length)return this;if(this.length>1)return this.each(function(){t(this).bxSlider(n)}),this;var s={},o=this,r=t(window).width(),a=t(window).height();if(!t(o).data("bxSlider")){var l=function(){t(o).data("bxSlider")||(s.settings=t.extend({},e,n),s.settings.slideWidth=parseInt(s.settings.slideWidth),s.children=o.children(s.settings.slideSelector),s.children.length<s.settings.minSlides&&(s.settings.minSlides=s.children.length),s.children.length<s.settings.maxSlides&&(s.settings.maxSlides=s.children.length),s.settings.randomStart&&(s.settings.startSlide=Math.floor(Math.random()*s.children.length)),s.active={index:s.settings.startSlide},s.carousel=s.settings.minSlides>1||s.settings.maxSlides>1,s.carousel&&(s.settings.preloadImages="all"),s.minThreshold=s.settings.minSlides*s.settings.slideWidth+(s.settings.minSlides-1)*s.settings.slideMargin,s.maxThreshold=s.settings.maxSlides*s.settings.slideWidth+(s.settings.maxSlides-1)*s.settings.slideMargin,s.working=!1,s.controls={},s.interval=null,s.animProp="vertical"===s.settings.mode?"top":"left",s.usingCSS=s.settings.useCSS&&"fade"!==s.settings.mode&&function(){for(var t=document.createElement("div"),e=["WebkitPerspective","MozPerspective","OPerspective","msPerspective"],i=0;i<e.length;i++)if(void 0!==t.style[e[i]])return s.cssPrefix=e[i].replace("Perspective","").toLowerCase(),s.animProp="-"+s.cssPrefix+"-transform",!0;return!1}(),"vertical"===s.settings.mode&&(s.settings.maxSlides=s.settings.minSlides),o.data("origStyle",o.attr("style")),o.children(s.settings.slideSelector).each(function(){t(this).data("origStyle",t(this).attr("style"))}),d())},d=function(){var e=s.children.eq(s.settings.startSlide);o.wrap('<div class="'+s.settings.wrapperClass+'"><div class="bx-viewport"></div></div>'),s.viewport=o.parent(),s.settings.ariaLive&&!s.settings.ticker&&s.viewport.attr("aria-live","polite"),s.loader=t('<div class="bx-loading" />'),s.viewport.prepend(s.loader),o.css({width:"horizontal"===s.settings.mode?1e3*s.children.length+215+"%":"auto",position:"relative"}),s.usingCSS&&s.settings.easing?o.css("-"+s.cssPrefix+"-transition-timing-function",s.settings.easing):s.settings.easing||(s.settings.easing="swing"),s.viewport.css({width:"100%",overflow:"hidden",position:"relative"}),s.viewport.parent().css({maxWidth:u()}),s.children.css({float:"horizontal"===s.settings.mode?"left":"none",listStyle:"none",position:"relative"}),s.children.css("width",h()),"horizontal"===s.settings.mode&&s.settings.slideMargin>0&&s.children.css("marginRight",s.settings.slideMargin),"vertical"===s.settings.mode&&s.settings.slideMargin>0&&s.children.css("marginBottom",s.settings.slideMargin),"fade"===s.settings.mode&&(s.children.css({position:"absolute",zIndex:0,display:"none"}),s.children.eq(s.settings.startSlide).css({zIndex:s.settings.slideZIndex,display:"block"})),s.controls.el=t('<div class="bx-controls" />'),s.settings.captions&&P(),s.active.last=s.settings.startSlide===f()-1,s.settings.video&&o.fitVids(),("all"===s.settings.preloadImages||s.settings.ticker)&&(e=s.children),s.settings.ticker?s.settings.pager=!1:(s.settings.controls&&C(),s.settings.auto&&s.settings.autoControls&&T(),s.settings.pager&&w(),(s.settings.controls||s.settings.autoControls||s.settings.pager)&&s.viewport.after(s.controls.el)),c(e,g)},c=function(e,i){var n=e.find('img:not([src=""]), iframe').length,s=0;if(0===n)return void i();e.find('img:not([src=""]), iframe').each(function(){t(this).one("load error",function(){++s===n&&i()}).each(function(){(this.complete||""==this.src)&&t(this).trigger("load")})})},g=function(){if(s.settings.infiniteLoop&&"fade"!==s.settings.mode&&!s.settings.ticker){var e="vertical"===s.settings.mode?s.settings.minSlides:s.settings.maxSlides,i=s.children.slice(0,e).clone(!0).addClass("bx-clone"),n=s.children.slice(-e).clone(!0).addClass("bx-clone");s.settings.ariaHidden&&(i.attr("aria-hidden",!0),n.attr("aria-hidden",!0)),o.append(i).prepend(n)}s.loader.remove(),m(),"vertical"===s.settings.mode&&(s.settings.adaptiveHeight=!0),s.viewport.height(p()),o.redrawSlider(),s.settings.onSliderLoad.call(o,s.active.index),s.initialized=!0,s.settings.responsive&&t(window).bind("resize",U),s.settings.auto&&s.settings.autoStart&&(f()>1||s.settings.autoSlideForOnePage)&&L(),s.settings.ticker&&O(),s.settings.pager&&I(s.settings.startSlide),s.settings.controls&&D(),s.settings.touchEnabled&&!s.settings.ticker&&Y(),s.settings.keyboardEnabled&&!s.settings.ticker&&t(document).keydown(X)},p=function(){var e=0,n=t();if("vertical"===s.settings.mode||s.settings.adaptiveHeight)if(s.carousel){var o=1===s.settings.moveSlides?s.active.index:s.active.index*x();for(n=s.children.eq(o),i=1;i<=s.settings.maxSlides-1;i++)n=o+i>=s.children.length?n.add(s.children.eq(i-1)):n.add(s.children.eq(o+i))}else n=s.children.eq(s.active.index);else n=s.children;return"vertical"===s.settings.mode?(n.each(function(i){e+=t(this).outerHeight()}),s.settings.slideMargin>0&&(e+=s.settings.slideMargin*(s.settings.minSlides-1))):e=Math.max.apply(Math,n.map(function(){return t(this).outerHeight(!1)}).get()),"border-box"===s.viewport.css("box-sizing")?e+=parseFloat(s.viewport.css("padding-top"))+parseFloat(s.viewport.css("padding-bottom"))+parseFloat(s.viewport.css("border-top-width"))+parseFloat(s.viewport.css("border-bottom-width")):"padding-box"===s.viewport.css("box-sizing")&&(e+=parseFloat(s.viewport.css("padding-top"))+parseFloat(s.viewport.css("padding-bottom"))),e},u=function(){var t="100%";return s.settings.slideWidth>0&&(t="horizontal"===s.settings.mode?s.settings.maxSlides*s.settings.slideWidth+(s.settings.maxSlides-1)*s.settings.slideMargin:s.settings.slideWidth),t},h=function(){var t=s.settings.slideWidth,e=s.viewport.width();if(0===s.settings.slideWidth||s.settings.slideWidth>e&&!s.carousel||"vertical"===s.settings.mode)t=e;else if(s.settings.maxSlides>1&&"horizontal"===s.settings.mode){if(e>s.maxThreshold)return t;e<s.minThreshold?t=(e-s.settings.slideMargin*(s.settings.minSlides-1))/s.settings.minSlides:s.settings.shrinkItems&&(t=Math.floor((e+s.settings.slideMargin)/Math.ceil((e+s.settings.slideMargin)/(t+s.settings.slideMargin))-s.settings.slideMargin))}return t},v=function(){var t=1,e=null;return"horizontal"===s.settings.mode&&s.settings.slideWidth>0?s.viewport.width()<s.minThreshold?t=s.settings.minSlides:s.viewport.width()>s.maxThreshold?t=s.settings.maxSlides:(e=s.children.first().width()+s.settings.slideMargin,t=Math.floor((s.viewport.width()+s.settings.slideMargin)/e)||1):"vertical"===s.settings.mode&&(t=s.settings.minSlides),t},f=function(){var t=0,e=0,i=0;if(s.settings.moveSlides>0){if(!s.settings.infiniteLoop){for(;e<s.children.length;)++t,e=i+v(),i+=s.settings.moveSlides<=v()?s.settings.moveSlides:v();return i}t=Math.ceil(s.children.length/x())}else t=Math.ceil(s.children.length/v());return t},x=function(){return s.settings.moveSlides>0&&s.settings.moveSlides<=v()?s.settings.moveSlides:v()},m=function(){var t,e,i;s.children.length>s.settings.maxSlides&&s.active.last&&!s.settings.infiniteLoop?"horizontal"===s.settings.mode?(e=s.children.last(),t=e.position(),S(-(t.left-(s.viewport.width()-e.outerWidth())),"reset",0)):"vertical"===s.settings.mode&&(i=s.children.length-s.settings.minSlides,t=s.children.eq(i).position(),S(-t.top,"reset",0)):(t=s.children.eq(s.active.index*x()).position(),s.active.index===f()-1&&(s.active.last=!0),void 0!==t&&("horizontal"===s.settings.mode?S(-t.left,"reset",0):"vertical"===s.settings.mode&&S(-t.top,"reset",0)))},S=function(e,i,n,r){var a,l;s.usingCSS?(l="vertical"===s.settings.mode?"translate3d(0, "+e+"px, 0)":"translate3d("+e+"px, 0, 0)",o.css("-"+s.cssPrefix+"-transition-duration",n/1e3+"s"),"slide"===i?(o.css(s.animProp,l),0!==n?o.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",function(e){t(e.target).is(o)&&(o.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"),A())}):A()):"reset"===i?o.css(s.animProp,l):"ticker"===i&&(o.css("-"+s.cssPrefix+"-transition-timing-function","linear"),o.css(s.animProp,l),0!==n?o.bind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",function(e){t(e.target).is(o)&&(o.unbind("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"),S(r.resetValue,"reset",0),F())}):(S(r.resetValue,"reset",0),F()))):(a={},a[s.animProp]=e,"slide"===i?o.animate(a,n,s.settings.easing,function(){A()}):"reset"===i?o.css(s.animProp,e):"ticker"===i&&o.animate(a,n,"linear",function(){S(r.resetValue,"reset",0),F()}))},b=function(){for(var e="",i="",n=f(),o=0;o<n;o++)i="",s.settings.buildPager&&t.isFunction(s.settings.buildPager)||s.settings.pagerCustom?(i=s.settings.buildPager(o),s.pagerEl.addClass("bx-custom-pager")):(i=o+1,s.pagerEl.addClass("bx-default-pager")),e+='<div class="bx-pager-item"><a href="" data-slide-index="'+o+'" class="bx-pager-link">'+i+"</a></div>";s.pagerEl.html(e)},w=function(){s.settings.pagerCustom?s.pagerEl=t(s.settings.pagerCustom):(s.pagerEl=t('<div class="bx-pager" />'),s.settings.pagerSelector?t(s.settings.pagerSelector).html(s.pagerEl):s.controls.el.addClass("bx-has-pager").append(s.pagerEl),b()),s.pagerEl.on("click touchend","a",z)},C=function(){s.controls.next=t('<a class="bx-next" href="">'+s.settings.nextText+"</a>"),s.controls.prev=t('<a class="bx-prev" href="">'+s.settings.prevText+"</a>"),s.controls.next.bind("click touchend",k),s.controls.prev.bind("click touchend",E),s.settings.nextSelector&&t(s.settings.nextSelector).append(s.controls.next),s.settings.prevSelector&&t(s.settings.prevSelector).append(s.controls.prev),s.settings.nextSelector||s.settings.prevSelector||(s.controls.directionEl=t('<div class="bx-controls-direction" />'),s.controls.directionEl.append(s.controls.prev).append(s.controls.next),s.controls.el.addClass("bx-has-controls-direction").append(s.controls.directionEl))},T=function(){s.controls.start=t('<div class="bx-controls-auto-item"><a class="bx-start" href="">'+s.settings.startText+"</a></div>"),s.controls.stop=t('<div class="bx-controls-auto-item"><a class="bx-stop" href="">'+s.settings.stopText+"</a></div>"),s.controls.autoEl=t('<div class="bx-controls-auto" />'),s.controls.autoEl.on("click",".bx-start",M),s.controls.autoEl.on("click",".bx-stop",y),s.settings.autoControlsCombine?s.controls.autoEl.append(s.controls.start):s.controls.autoEl.append(s.controls.start).append(s.controls.stop),s.settings.autoControlsSelector?t(s.settings.autoControlsSelector).html(s.controls.autoEl):s.controls.el.addClass("bx-has-controls-auto").append(s.controls.autoEl),q(s.settings.autoStart?"stop":"start")},P=function(){s.children.each(function(e){var i=t(this).find("img:first").attr("title");void 0!==i&&(""+i).length&&t(this).append('<div class="bx-caption"><span>'+i+"</span></div>")})},k=function(t){t.preventDefault(),s.controls.el.hasClass("disabled")||(s.settings.auto&&s.settings.stopAutoOnClick&&o.stopAuto(),o.goToNextSlide())},E=function(t){t.preventDefault(),s.controls.el.hasClass("disabled")||(s.settings.auto&&s.settings.stopAutoOnClick&&o.stopAuto(),o.goToPrevSlide())},M=function(t){o.startAuto(),t.preventDefault()},y=function(t){o.stopAuto(),t.preventDefault()},z=function(e){var i,n;e.preventDefault(),s.controls.el.hasClass("disabled")||(s.settings.auto&&s.settings.stopAutoOnClick&&o.stopAuto(),i=t(e.currentTarget),void 0!==i.attr("data-slide-index")&&(n=parseInt(i.attr("data-slide-index")))!==s.active.index&&o.goToSlide(n))},I=function(e){var i=s.children.length;if("short"===s.settings.pagerType)return s.settings.maxSlides>1&&(i=Math.ceil(s.children.length/s.settings.maxSlides)),void s.pagerEl.html(e+1+s.settings.pagerShortSeparator+i);s.pagerEl.find("a").removeClass("active"),s.pagerEl.each(function(i,n){t(n).find("a").eq(e).addClass("active")})},A=function(){if(s.settings.infiniteLoop){var t="";0===s.active.index?t=s.children.eq(0).position():s.active.index===f()-1&&s.carousel?t=s.children.eq((f()-1)*x()).position():s.active.index===s.children.length-1&&(t=s.children.eq(s.children.length-1).position()),t&&("horizontal"===s.settings.mode?S(-t.left,"reset",0):"vertical"===s.settings.mode&&S(-t.top,"reset",0))}s.working=!1,s.settings.onSlideAfter.call(o,s.children.eq(s.active.index),s.oldIndex,s.active.index)},q=function(t){s.settings.autoControlsCombine?s.controls.autoEl.html(s.controls[t]):(s.controls.autoEl.find("a").removeClass("active"),s.controls.autoEl.find("a:not(.bx-"+t+")").addClass("active"))},D=function(){1===f()?(s.controls.prev.addClass("disabled"),s.controls.next.addClass("disabled")):!s.settings.infiniteLoop&&s.settings.hideControlOnEnd&&(0===s.active.index?(s.controls.prev.addClass("disabled"),s.controls.next.removeClass("disabled")):s.active.index===f()-1?(s.controls.next.addClass("disabled"),s.controls.prev.removeClass("disabled")):(s.controls.prev.removeClass("disabled"),s.controls.next.removeClass("disabled")))},H=function(){o.startAuto()},W=function(){o.stopAuto()},L=function(){if(s.settings.autoDelay>0){setTimeout(o.startAuto,s.settings.autoDelay)}else o.startAuto(),t(window).focus(H).blur(W);s.settings.autoHover&&o.hover(function(){s.interval&&(o.stopAuto(!0),s.autoPaused=!0)},function(){s.autoPaused&&(o.startAuto(!0),s.autoPaused=null)})},O=function(){var e,i,n,r,a,l,d,c,g=0;"next"===s.settings.autoDirection?o.append(s.children.clone().addClass("bx-clone")):(o.prepend(s.children.clone().addClass("bx-clone")),e=s.children.first().position(),g="horizontal"===s.settings.mode?-e.left:-e.top),S(g,"reset",0),s.settings.pager=!1,s.settings.controls=!1,s.settings.autoControls=!1,s.settings.tickerHover&&(s.usingCSS?(r="horizontal"===s.settings.mode?4:5,s.viewport.hover(function(){i=o.css("-"+s.cssPrefix+"-transform"),n=parseFloat(i.split(",")[r]),S(n,"reset",0)},function(){c=0,s.children.each(function(e){c+="horizontal"===s.settings.mode?t(this).outerWidth(!0):t(this).outerHeight(!0)}),a=s.settings.speed/c,l="horizontal"===s.settings.mode?"left":"top",d=a*(c-Math.abs(parseInt(n))),F(d)})):s.viewport.hover(function(){o.stop()},function(){c=0,s.children.each(function(e){c+="horizontal"===s.settings.mode?t(this).outerWidth(!0):t(this).outerHeight(!0)}),a=s.settings.speed/c,l="horizontal"===s.settings.mode?"left":"top",d=a*(c-Math.abs(parseInt(o.css(l)))),F(d)})),F()},F=function(t){var e,i,n,r=t?t:s.settings.speed,a={left:0,top:0},l={left:0,top:0};"next"===s.settings.autoDirection?a=o.find(".bx-clone").first().position():l=s.children.first().position(),e="horizontal"===s.settings.mode?-a.left:-a.top,i="horizontal"===s.settings.mode?-l.left:-l.top,n={resetValue:i},S(e,"ticker",r,n)},N=function(e){var i=t(window),n={top:i.scrollTop(),left:i.scrollLeft()},s=e.offset();return n.right=n.left+i.width(),n.bottom=n.top+i.height(),s.right=s.left+e.outerWidth(),s.bottom=s.top+e.outerHeight(),!(n.right<s.left||n.left>s.right||n.bottom<s.top||n.top>s.bottom)},X=function(t){var e=document.activeElement.tagName.toLowerCase();if(null==new RegExp(e,["i"]).exec("input|textarea")&&N(o)){if(39===t.keyCode)return k(t),!1;if(37===t.keyCode)return E(t),!1}},Y=function(){s.touch={start:{x:0,y:0},end:{x:0,y:0}},s.viewport.bind("touchstart MSPointerDown pointerdown",V),s.viewport.on("click",".bxslider a",function(t){s.viewport.hasClass("click-disabled")&&(t.preventDefault(),s.viewport.removeClass("click-disabled"))})},V=function(t){if(s.controls.el.addClass("disabled"),s.working)t.preventDefault(),s.controls.el.removeClass("disabled");else{s.touch.originalPos=o.position();var e=t.originalEvent,i=void 0!==e.changedTouches?e.changedTouches:[e];s.touch.start.x=i[0].pageX,s.touch.start.y=i[0].pageY,s.viewport.get(0).setPointerCapture&&(s.pointerId=e.pointerId,s.viewport.get(0).setPointerCapture(s.pointerId)),s.viewport.bind("touchmove MSPointerMove pointermove",Z),s.viewport.bind("touchend MSPointerUp pointerup",B),s.viewport.bind("MSPointerCancel pointercancel",R)}},R=function(t){S(s.touch.originalPos.left,"reset",0),s.controls.el.removeClass("disabled"),s.viewport.unbind("MSPointerCancel pointercancel",R),s.viewport.unbind("touchmove MSPointerMove pointermove",Z),s.viewport.unbind("touchend MSPointerUp pointerup",B),s.viewport.get(0).releasePointerCapture&&s.viewport.get(0).releasePointerCapture(s.pointerId)},Z=function(t){var e=t.originalEvent,i=void 0!==e.changedTouches?e.changedTouches:[e],n=Math.abs(i[0].pageX-s.touch.start.x),o=Math.abs(i[0].pageY-s.touch.start.y),r=0,a=0;3*n>o&&s.settings.preventDefaultSwipeX?t.preventDefault():3*o>n&&s.settings.preventDefaultSwipeY&&t.preventDefault(),"fade"!==s.settings.mode&&s.settings.oneToOneTouch&&("horizontal"===s.settings.mode?(a=i[0].pageX-s.touch.start.x,r=s.touch.originalPos.left+a):(a=i[0].pageY-s.touch.start.y,r=s.touch.originalPos.top+a),S(r,"reset",0))},B=function(t){s.viewport.unbind("touchmove MSPointerMove pointermove",Z),s.controls.el.removeClass("disabled");var e=t.originalEvent,i=void 0!==e.changedTouches?e.changedTouches:[e],n=0,r=0;s.touch.end.x=i[0].pageX,s.touch.end.y=i[0].pageY,"fade"===s.settings.mode?(r=Math.abs(s.touch.start.x-s.touch.end.x))>=s.settings.swipeThreshold&&(s.touch.start.x>s.touch.end.x?o.goToNextSlide():o.goToPrevSlide(),o.stopAuto()):("horizontal"===s.settings.mode?(r=s.touch.end.x-s.touch.start.x,n=s.touch.originalPos.left):(r=s.touch.end.y-s.touch.start.y,n=s.touch.originalPos.top),!s.settings.infiniteLoop&&(0===s.active.index&&r>0||s.active.last&&r<0)?S(n,"reset",200):Math.abs(r)>=s.settings.swipeThreshold?(r<0?o.goToNextSlide():o.goToPrevSlide(),o.stopAuto()):S(n,"reset",200)),s.viewport.unbind("touchend MSPointerUp pointerup",B),s.viewport.get(0).releasePointerCapture&&s.viewport.get(0).releasePointerCapture(s.pointerId)},U=function(e){if(s.initialized)if(s.working)window.setTimeout(U,10);else{var i=t(window).width(),n=t(window).height();r===i&&a===n||(r=i,a=n,o.redrawSlider(),s.settings.onSliderResize.call(o,s.active.index))}},j=function(t){var e=v();s.settings.ariaHidden&&!s.settings.ticker&&(s.children.attr("aria-hidden","true"),s.children.slice(t,t+e).attr("aria-hidden","false"))},Q=function(t){return t<0?s.settings.infiniteLoop?f()-1:s.active.index:t>=f()?s.settings.infiniteLoop?0:s.active.index:t};return o.goToSlide=function(e,i){var n,r,a,l,d=!0,c=0,g={left:0,top:0},u=null;if(s.oldIndex=s.active.index,s.active.index=Q(e),!s.working&&s.active.index!==s.oldIndex){if(s.working=!0,void 0!==(d=s.settings.onSlideBefore.call(o,s.children.eq(s.active.index),s.oldIndex,s.active.index))&&!d)return s.active.index=s.oldIndex,void(s.working=!1);"next"===i?s.settings.onSlideNext.call(o,s.children.eq(s.active.index),s.oldIndex,s.active.index)||(d=!1):"prev"===i&&(s.settings.onSlidePrev.call(o,s.children.eq(s.active.index),s.oldIndex,s.active.index)||(d=!1)),s.active.last=s.active.index>=f()-1,(s.settings.pager||s.settings.pagerCustom)&&I(s.active.index),s.settings.controls&&D(),"fade"===s.settings.mode?(s.settings.adaptiveHeight&&s.viewport.height()!==p()&&s.viewport.animate({height:p()},s.settings.adaptiveHeightSpeed),s.children.filter(":visible").fadeOut(s.settings.speed).css({zIndex:0}),s.children.eq(s.active.index).css("zIndex",s.settings.slideZIndex+1).fadeIn(s.settings.speed,function(){t(this).css("zIndex",s.settings.slideZIndex),A()})):(s.settings.adaptiveHeight&&s.viewport.height()!==p()&&s.viewport.animate({height:p()},s.settings.adaptiveHeightSpeed),!s.settings.infiniteLoop&&s.carousel&&s.active.last?"horizontal"===s.settings.mode?(u=s.children.eq(s.children.length-1),g=u.position(),c=s.viewport.width()-u.outerWidth()):(n=s.children.length-s.settings.minSlides,g=s.children.eq(n).position()):s.carousel&&s.active.last&&"prev"===i?(r=1===s.settings.moveSlides?s.settings.maxSlides-x():(f()-1)*x()-(s.children.length-s.settings.maxSlides),u=o.children(".bx-clone").eq(r),g=u.position()):"next"===i&&0===s.active.index?(g=o.find("> .bx-clone").eq(s.settings.maxSlides).position(),s.active.last=!1):e>=0&&(l=e*parseInt(x()),g=s.children.eq(l).position()),void 0!==g&&(a="horizontal"===s.settings.mode?-(g.left-c):-g.top,S(a,"slide",s.settings.speed)),s.working=!1),s.settings.ariaHidden&&j(s.active.index*x())}},o.goToNextSlide=function(){if((s.settings.infiniteLoop||!s.active.last)&&1!=s.working){var t=parseInt(s.active.index)+1;o.goToSlide(t,"next")}},o.goToPrevSlide=function(){if((s.settings.infiniteLoop||0!==s.active.index)&&1!=s.working){var t=parseInt(s.active.index)-1;o.goToSlide(t,"prev")}},o.startAuto=function(t){s.interval||(s.interval=setInterval(function(){"next"===s.settings.autoDirection?o.goToNextSlide():o.goToPrevSlide()},s.settings.pause),s.settings.onAutoChange.call(o,!0),s.settings.autoControls&&t!==!0&&q("stop"))},o.stopAuto=function(t){s.interval&&(clearInterval(s.interval),s.interval=null,s.settings.onAutoChange.call(o,!1),s.settings.autoControls&&t!==!0&&q("start"))},o.getCurrentSlide=function(){return s.active.index},o.getCurrentSlideElement=function(){return s.children.eq(s.active.index)},o.getSlideElement=function(t){return s.children.eq(t)},o.getSlideCount=function(){return s.children.length},o.isWorking=function(){return s.working},o.redrawSlider=function(){s.children.add(o.find(".bx-clone")).outerWidth(h()),s.viewport.css("height",p()),s.settings.ticker||m(),s.active.last&&(s.active.index=f()-1),s.active.index>=f()&&(s.active.last=!0),s.settings.pager&&!s.settings.pagerCustom&&(b(),I(s.active.index)),s.settings.ariaHidden&&j(s.active.index*x())},o.destroySlider=function(){s.initialized&&(s.initialized=!1,t(".bx-clone",this).remove(),s.children.each(function(){void 0!==t(this).data("origStyle")?t(this).attr("style",t(this).data("origStyle")):t(this).removeAttr("style")}),void 0!==t(this).data("origStyle")?this.attr("style",t(this).data("origStyle")):t(this).removeAttr("style"),t(this).unwrap().unwrap(),s.controls.el&&s.controls.el.remove(),s.controls.next&&s.controls.next.remove(),s.controls.prev&&s.controls.prev.remove(),s.pagerEl&&s.settings.controls&&!s.settings.pagerCustom&&s.pagerEl.remove(),t(".bx-caption",this).remove(),s.controls.autoEl&&s.controls.autoEl.remove(),clearInterval(s.interval),s.settings.responsive&&t(window).unbind("resize",U),s.settings.keyboardEnabled&&t(document).unbind("keydown",X),t(this).removeData("bxSlider"),t(window).off("blur",W).off("focus",H))},o.reloadSlider=function(e){void 0!==e&&(n=e),o.destroySlider(),l(),t(o).data("bxSlider",this)},l(),t(o).data("bxSlider",this),this}}}(jQuery);

        /**
         * jquery-date-range-picker
         * @version v0.18.0
         * @link https://github.com/longbill/jquery-date-range-picker
         * @license MIT
         */
        !function(e){"function"==typeof define&&define.amd?define(["jquery","moment"],e):"object"==typeof exports&&"undefined"!=typeof module?module.exports=e(require("jquery"),require("moment")):e(jQuery,moment)}(function(e,t){"use strict";e.dateRangePickerLanguages={default:{selected:"Selected:",day:"Day",days:"Days",apply:"Close","week-1":"mo","week-2":"tu","week-3":"we","week-4":"th","week-5":"fr","week-6":"sa","week-7":"su","week-number":"W","month-name":["january","february","march","april","may","june","july","august","september","october","november","december"],shortcuts:"Shortcuts","custom-values":"Custom Values",past:"Past",following:"Following",previous:"Previous","prev-week":"Week","prev-month":"Month","prev-year":"Year",next:"Next","next-week":"Week","next-month":"Month","next-year":"Year","less-than":"Date range should not be more than %d days","more-than":"Date range should not be less than %d days","default-more":"Please select a date range longer than %d days","default-single":"Please select a date","default-less":"Please select a date range less than %d days","default-range":"Please select a date range between %d and %d days","default-default":"Please select a date range",time:"Time",hour:"Hour",minute:"Minute"},id:{selected:"Terpilih:",day:"Hari",days:"Hari",apply:"Tutup","week-1":"sen","week-2":"sel","week-3":"rab","week-4":"kam","week-5":"jum","week-6":"sab","week-7":"min","week-number":"W","month-name":["januari","februari","maret","april","mei","juni","juli","agustus","september","oktober","november","desember"],shortcuts:"Pintas","custom-values":"Nilai yang ditentukan",past:"Yang Lalu",following:"Mengikuti",previous:"Sebelumnya","prev-week":"Minggu","prev-month":"Bulan","prev-year":"Tahun",next:"Selanjutnya","next-week":"Minggu","next-month":"Bulan","next-year":"Tahun","less-than":"Tanggal harus lebih dari %d hari","more-than":"Tanggal harus kurang dari %d hari","default-more":"Jarak tanggal harus lebih lama dari %d hari","default-single":"Silakan pilih tanggal","default-less":"Jarak rentang tanggal tidak boleh lebih lama dari %d hari","default-range":"Rentang tanggal harus antara %d dan %d hari","default-default":"Silakan pilih rentang tanggal",time:"Waktu",hour:"Jam",minute:"Menit"},az:{selected:"Seçildi:",day:" gün",days:" gün",apply:"tətbiq","week-1":"1","week-2":"2","week-3":"3","week-4":"4","week-5":"5","week-6":"6","week-7":"7","month-name":["yanvar","fevral","mart","aprel","may","iyun","iyul","avqust","sentyabr","oktyabr","noyabr","dekabr"],shortcuts:"Qısayollar",past:"Keçmiş",following:"Növbəti",previous:"&nbsp;&nbsp;&nbsp;","prev-week":"Öncəki həftə","prev-month":"Öncəki ay","prev-year":"Öncəki il",next:"&nbsp;&nbsp;&nbsp;","next-week":"Növbəti həftə","next-month":"Növbəti ay","next-year":"Növbəti il","less-than":"Tarix aralığı %d gündən çox olmamalıdır","more-than":"Tarix aralığı %d gündən az olmamalıdır","default-more":"%d gündən çox bir tarix seçin","default-single":"Tarix seçin","default-less":"%d gündən az bir tarix seçin","default-range":"%d və %d gün aralığında tarixlər seçin","default-default":"Tarix aralığı seçin"},bg:{selected:"Избрано:",day:"Ден",days:"Дни",apply:"Затвори","week-1":"пн","week-2":"вт","week-3":"ср","week-4":"чт","week-5":"пт","week-6":"сб","week-7":"нд","week-number":"С","month-name":["януари","февруари","март","април","май","юни","юли","август","септември","октомври","ноември","декември"],shortcuts:"Преки пътища","custom-values":"Персонализирани стойности",past:"Минал",following:"Следващ",previous:"Предишен","prev-week":"Седмица","prev-month":"Месец","prev-year":"Година",next:"Следващ","next-week":"Седмица","next-month":"Месец","next-year":"Година","less-than":"Периодът от време не трябва да е повече от %d дни","more-than":"Периодът от време не трябва да е по-малко от %d дни","default-more":"Моля изберете период по-дълъг от %d дни","default-single":"Моля изберете дата","default-less":"Моля изберете период по-къс от %d дни","default-range":"Моля изберете период между %d и %d дни","default-default":"Моля изберете период",time:"Време",hour:"Час",minute:"Минута"},cn:{selected:"已选择:",day:"天",days:"天",apply:"确定","week-1":"一","week-2":"二","week-3":"三","week-4":"四","week-5":"五","week-6":"六","week-7":"日","week-number":"周","month-name":["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],shortcuts:"快捷选择",past:"过去",following:"将来",previous:"&nbsp;&nbsp;&nbsp;","prev-week":"上周","prev-month":"上个月","prev-year":"去年",next:"&nbsp;&nbsp;&nbsp;","next-week":"下周","next-month":"下个月","next-year":"明年","less-than":"所选日期范围不能大于%d天","more-than":"所选日期范围不能小于%d天","default-more":"请选择大于%d天的日期范围","default-less":"请选择小于%d天的日期范围","default-range":"请选择%d天到%d天的日期范围","default-single":"请选择一个日期","default-default":"请选择一个日期范围",time:"时间",hour:"小时",minute:"分钟"},cz:{selected:"Vybráno:",day:"Den",days:"Dny",apply:"Zavřít","week-1":"po","week-2":"út","week-3":"st","week-4":"čt","week-5":"pá","week-6":"so","week-7":"ne","month-name":["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],shortcuts:"Zkratky",past:"po",following:"následující",previous:"předchozí","prev-week":"týden","prev-month":"měsíc","prev-year":"rok",next:"další","next-week":"týden","next-month":"měsíc","next-year":"rok","less-than":"Rozsah data by neměl být větší než %d dnů","more-than":"Rozsah data by neměl být menší než %d dnů","default-more":"Prosím zvolte rozsah data větší než %d dnů","default-single":"Prosím zvolte datum","default-less":"Prosím zvolte rozsah data menší než %d dnů","default-range":"Prosím zvolte rozsah data mezi %d a %d dny","default-default":"Prosím zvolte rozsah data"},de:{selected:"Auswahl:",day:"Tag",days:"Tage",apply:"Schließen","week-1":"mo","week-2":"di","week-3":"mi","week-4":"do","week-5":"fr","week-6":"sa","week-7":"so","month-name":["januar","februar","märz","april","mai","juni","juli","august","september","oktober","november","dezember"],shortcuts:"Schnellwahl",past:"Vorherige",following:"Folgende",previous:"Vorherige","prev-week":"Woche","prev-month":"Monat","prev-year":"Jahr",next:"Nächste","next-week":"Woche","next-month":"Monat","next-year":"Jahr","less-than":"Datumsbereich darf nicht größer sein als %d Tage","more-than":"Datumsbereich darf nicht kleiner sein als %d Tage","default-more":"Bitte mindestens %d Tage auswählen","default-single":"Bitte ein Datum auswählen","default-less":"Bitte weniger als %d Tage auswählen","default-range":"Bitte einen Datumsbereich zwischen %d und %d Tagen auswählen","default-default":"Bitte ein Start- und Enddatum auswählen",Time:"Zeit",hour:"Stunde",minute:"Minute"},es:{selected:"Seleccionado:",day:"Día",days:"Días",apply:"Cerrar","week-1":"lu","week-2":"ma","week-3":"mi","week-4":"ju","week-5":"vi","week-6":"sa","week-7":"do","month-name":["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],shortcuts:"Accesos directos",past:"Pasado",following:"Siguiente",previous:"Anterior","prev-week":"Semana","prev-month":"Mes","prev-year":"Año",next:"Siguiente","next-week":"Semana","next-month":"Mes","next-year":"Año","less-than":"El rango no debería ser mayor de %d días","more-than":"El rango no debería ser menor de %d días","default-more":"Por favor selecciona un rango mayor a %d días","default-single":"Por favor selecciona un día","default-less":"Por favor selecciona un rango menor a %d días","default-range":"Por favor selecciona un rango entre %d y %d días","default-default":"Por favor selecciona un rango de fechas."},fr:{selected:"Sélection:",day:"Jour",days:"Jours",apply:"Fermer","week-1":"lu","week-2":"ma","week-3":"me","week-4":"je","week-5":"ve","week-6":"sa","week-7":"di","month-name":["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],shortcuts:"Raccourcis",past:"Passé",following:"Suivant",previous:"Précédent","prev-week":"Semaine","prev-month":"Mois","prev-year":"Année",next:"Suivant","next-week":"Semaine","next-month":"Mois","next-year":"Année","less-than":"L'intervalle ne doit pas être supérieure à %d jours","more-than":"L'intervalle ne doit pas être inférieure à %d jours","default-more":"Merci de choisir une intervalle supérieure à %d jours","default-single":"Merci de choisir une date","default-less":"Merci de choisir une intervalle inférieure %d jours","default-range":"Merci de choisir une intervalle comprise entre %d et %d jours","default-default":"Merci de choisir une date"},hu:{selected:"Kiválasztva:",day:"Nap",days:"Nap",apply:"Ok","week-1":"h","week-2":"k","week-3":"sz","week-4":"cs","week-5":"p","week-6":"sz","week-7":"v","month-name":["január","február","március","április","május","június","július","augusztus","szeptember","október","november","december"],shortcuts:"Gyorsválasztó",past:"Múlt",following:"Következő",previous:"Előző","prev-week":"Hét","prev-month":"Hónap","prev-year":"Év",next:"Következő","next-week":"Hét","next-month":"Hónap","next-year":"Év","less-than":"A kiválasztás nem lehet több %d napnál","more-than":"A kiválasztás nem lehet több %d napnál","default-more":"Válassz ki egy időszakot ami hosszabb mint %d nap","default-single":"Válassz egy napot","default-less":"Válassz ki egy időszakot ami rövidebb mint %d nap","default-range":"Válassz ki egy %d - %d nap hosszú időszakot","default-default":"Válassz ki egy időszakot"},it:{selected:"Selezionati:",day:"Giorno",days:"Giorni",apply:"Chiudi","week-1":"lu","week-2":"ma","week-3":"me","week-4":"gi","week-5":"ve","week-6":"sa","week-7":"do","month-name":["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"],shortcuts:"Scorciatoie",past:"Scorso",following:"Successivo",previous:"Precedente","prev-week":"Settimana","prev-month":"Mese","prev-year":"Anno",next:"Prossimo","next-week":"Settimana","next-month":"Mese","next-year":"Anno","less-than":"L'intervallo non dev'essere maggiore di %d giorni","more-than":"L'intervallo non dev'essere minore di %d giorni","default-more":"Seleziona un intervallo maggiore di %d giorni","default-single":"Seleziona una data","default-less":"Seleziona un intervallo minore di %d giorni","default-range":"Seleziona un intervallo compreso tra i %d e i %d giorni","default-default":"Seleziona un intervallo di date"},ko:{selected:"기간:",day:"일",days:"일간",apply:"닫기","week-1":"월","week-2":"화","week-3":"수","week-4":"목","week-5":"금","week-6":"토","week-7":"일","week-number":"주","month-name":["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],shortcuts:"단축키들",past:"지난(오늘기준)",following:"이후(오늘기준)",previous:"이전","prev-week":"1주","prev-month":"1달","prev-year":"1년",next:"다음","next-week":"1주","next-month":"1달","next-year":"1년","less-than":"날짜 범위는 %d 일보다 많을 수 없습니다","more-than":"날짜 범위는 %d 일보다 작을 수 없습니다","default-more":"날짜 범위를 %d 일보다 길게 선택해 주세요","default-single":"날짜를 선택해 주세요","default-less":"%d 일보다 작은 날짜를 선택해 주세요","default-range":"%d와 %d 일 사이의 날짜 범위를 선택해 주세요","default-default":"날짜 범위를 선택해 주세요",time:"시각",hour:"시",minute:"분"},no:{selected:"Valgt:",day:"Dag",days:"Dager",apply:"Lukk","week-1":"ma","week-2":"ti","week-3":"on","week-4":"to","week-5":"fr","week-6":"lø","week-7":"sø","month-name":["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],shortcuts:"Snarveier","custom-values":"Egendefinerte Verdier",past:"Over",following:"Følger",previous:"Forrige","prev-week":"Uke","prev-month":"Måned","prev-year":"År",next:"Neste","next-week":"Uke","next-month":"Måned","next-year":"År","less-than":"Datoperioden skal ikkje være lengre enn %d dager","more-than":"Datoperioden skal ikkje være kortere enn %d dager","default-more":"Vennligst velg ein datoperiode lengre enn %d dager","default-single":"Vennligst velg ein dato","default-less":"Vennligst velg ein datoperiode mindre enn %d dager","default-range":"Vennligst velg ein datoperiode mellom %d og %d dager","default-default":"Vennligst velg ein datoperiode",time:"Tid",hour:"Time",minute:"Minutter"},nl:{selected:"Geselecteerd:",day:"Dag",days:"Dagen",apply:"Ok","week-1":"ma","week-2":"di","week-3":"wo","week-4":"do","week-5":"vr","week-6":"za","week-7":"zo","month-name":["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],shortcuts:"Snelkoppelingen","custom-values":"Aangepaste waarden",past:"Verleden",following:"Komend",previous:"Vorige","prev-week":"Week","prev-month":"Maand","prev-year":"Jaar",next:"Volgende","next-week":"Week","next-month":"Maand","next-year":"Jaar","less-than":"Interval moet langer dan %d dagen zijn","more-than":"Interval mag niet minder dan %d dagen zijn","default-more":"Selecteer een interval langer dan %dagen","default-single":"Selecteer een datum","default-less":"Selecteer een interval minder dan %d dagen","default-range":"Selecteer een interval tussen %d en %d dagen","default-default":"Selecteer een interval",time:"Tijd",hour:"Uur",minute:"Minuut"},ru:{selected:"Выбрано:",day:"День",days:"Дней",apply:"Применить","week-1":"пн","week-2":"вт","week-3":"ср","week-4":"чт","week-5":"пт","week-6":"сб","week-7":"вс","month-name":["январь","февраль","март","апрель","май","июнь","июль","август","сентябрь","октябрь","ноябрь","декабрь"],shortcuts:"Быстрый выбор","custom-values":"Пользовательские значения",past:"Прошедшие",following:"Следующие",previous:"&nbsp;&nbsp;&nbsp;","prev-week":"Неделя","prev-month":"Месяц","prev-year":"Год",next:"&nbsp;&nbsp;&nbsp;","next-week":"Неделя","next-month":"Месяц","next-year":"Год","less-than":"Диапазон не может быть больше %d дней","more-than":"Диапазон не может быть меньше %d дней","default-more":"Пожалуйста выберите диапазон больше %d дней","default-single":"Пожалуйста выберите дату","default-less":"Пожалуйста выберите диапазон меньше %d дней","default-range":"Пожалуйста выберите диапазон между %d и %d днями","default-default":"Пожалуйста выберите диапазон",time:"Время",hour:"Часы",minute:"Минуты"},uk:{selected:"Вибрано:",day:"День",days:"Днів",apply:"Застосувати","week-1":"пн","week-2":"вт","week-3":"ср","week-4":"чт","week-5":"пт","week-6":"сб","week-7":"нд","month-name":["січень","лютий","березень","квітень","травень","червень","липень","серпень","вересень","жовтень","листопад","грудень"],shortcuts:"Швидкий вибір","custom-values":"Значення користувача",past:"Минулі",following:"Наступні",previous:"&nbsp;&nbsp;&nbsp;","prev-week":"Тиждень","prev-month":"Місяць","prev-year":"Рік",next:"&nbsp;&nbsp;&nbsp;","next-week":"Тиждень","next-month":"Місяць","next-year":"Рік","less-than":"Діапазон не може бути більш ніж %d днів","more-than":"Діапазон не може бути меньш ніж %d днів","default-more":"Будь ласка виберіть діапазон більше %d днів","default-single":"Будь ласка виберіть дату","default-less":"Будь ласка виберіть діапазон менше %d днів","default-range":"Будь ласка виберіть діапазон між %d та %d днями","default-default":"Будь ласка виберіть діапазон",time:"Час",hour:"Години",minute:"Хвилини"},pl:{selected:"Wybrany:",day:"Dzień",days:"Dni",apply:"Zamknij","week-1":"pon","week-2":"wt","week-3":"śr","week-4":"czw","week-5":"pt","week-6":"so","week-7":"nd","month-name":["styczeń","luty","marzec","kwiecień","maj","czerwiec","lipiec","sierpień","wrzesień","październik","listopad","grudzień"],shortcuts:"Skróty","custom-values":"Niestandardowe wartości",past:"Przeszłe",following:"Następne",previous:"Poprzednie","prev-week":"tydzień","prev-month":"miesiąc","prev-year":"rok",next:"Następny","next-week":"tydzień","next-month":"miesiąc","next-year":"rok","less-than":"Okres nie powinien być dłuższy niż %d dni","more-than":"Okres nie powinien być krótszy niż  %d ni","default-more":"Wybierz okres dłuższy niż %d dni","default-single":"Wybierz datę","default-less":"Wybierz okres krótszy niż %d dni","default-range":"Wybierz okres trwający od %d do %d dni","default-default":"Wybierz okres",time:"Czas",hour:"Godzina",minute:"Minuta"},se:{selected:"Vald:",day:"dag",days:"dagar",apply:"godkänn","week-1":"ma","week-2":"ti","week-3":"on","week-4":"to","week-5":"fr","week-6":"lö","week-7":"sö","month-name":["januari","februari","mars","april","maj","juni","juli","augusti","september","oktober","november","december"],shortcuts:"genvägar","custom-values":"Anpassade värden",past:"över",following:"följande",previous:"förra","prev-week":"vecka","prev-month":"månad","prev-year":"år",next:"nästa","next-week":"vecka","next-month":"måned","next-year":"år","less-than":"Datumintervall bör inte vara mindre än %d dagar","more-than":"Datumintervall bör inte vara mer än %d dagar","default-more":"Välj ett datumintervall längre än %d dagar","default-single":"Välj ett datum","default-less":"Välj ett datumintervall mindre än %d dagar","default-range":"Välj ett datumintervall mellan %d och %d dagar","default-default":"Välj ett datumintervall",time:"tid",hour:"timme",minute:"minut"},pt:{selected:"Selecionado:",day:"Dia",days:"Dias",apply:"Fechar","week-1":"seg","week-2":"ter","week-3":"qua","week-4":"qui","week-5":"sex","week-6":"sab","week-7":"dom","week-number":"N","month-name":["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"],shortcuts:"Atalhos","custom-values":"Valores Personalizados",past:"Passado",following:"Seguinte",previous:"Anterior","prev-week":"Semana","prev-month":"Mês","prev-year":"Ano",next:"Próximo","next-week":"Próxima Semana","next-month":"Próximo Mês","next-year":"Próximo Ano","less-than":"O período selecionado não deve ser maior que %d dias","more-than":"O período selecionado não deve ser menor que %d dias","default-more":"Selecione um período superior a %d dias","default-single":"Selecione uma data","default-less":"Selecione um período inferior a %d dias","default-range":"Selecione um período de %d a %d dias","default-default":"Selecione um período",time:"Tempo",hour:"Hora",minute:"Minuto"},tc:{selected:"已選擇:",day:"天",days:"天",apply:"確定","week-1":"一","week-2":"二","week-3":"三","week-4":"四","week-5":"五","week-6":"六","week-7":"日","week-number":"周","month-name":["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],shortcuts:"快速選擇",past:"過去",following:"將來",previous:"&nbsp;&nbsp;&nbsp;","prev-week":"上週","prev-month":"上個月","prev-year":"去年",next:"&nbsp;&nbsp;&nbsp;","next-week":"下周","next-month":"下個月","next-year":"明年","less-than":"所選日期範圍不能大於%d天","more-than":"所選日期範圍不能小於%d天","default-more":"請選擇大於%d天的日期範圍","default-less":"請選擇小於%d天的日期範圍","default-range":"請選擇%d天到%d天的日期範圍","default-single":"請選擇一個日期","default-default":"請選擇一個日期範圍",time:"日期",hour:"小時",minute:"分鐘"},ja:{selected:"選択しました:",day:"日",days:"日々",apply:"閉じる","week-1":"月","week-2":"火","week-3":"水","week-4":"木","week-5":"金","week-6":"土","week-7":"日","month-name":["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],shortcuts:"クイック選択",past:"過去",following:"将来",previous:"&nbsp;&nbsp;&nbsp;","prev-week":"先週、","prev-month":"先月","prev-year":"昨年",next:"&nbsp;&nbsp;&nbsp;","next-week":"来週","next-month":"来月","next-year":"来年","less-than":"日付の範囲は ％d 日以上にすべきではありません","more-than":"日付の範囲は ％d 日を下回ってはいけません","default-more":"％d 日よりも長い期間を選択してください","default-less":"％d 日未満の期間を選択してください","default-range":"％d と％ d日の間の日付範囲を選択してください","default-single":"日付を選択してください","default-default":"日付範囲を選択してください",time:"時間",hour:"時間",minute:"分"},da:{selected:"Valgt:",day:"Dag",days:"Dage",apply:"Luk","week-1":"ma","week-2":"ti","week-3":"on","week-4":"to","week-5":"fr","week-6":"lö","week-7":"sö","month-name":["januar","februar","marts","april","maj","juni","juli","august","september","oktober","november","december"],shortcuts:"genveje","custom-values":"Brugerdefinerede værdier",past:"Forbi",following:"Følgende",previous:"Forrige","prev-week":"uge","prev-month":"månad","prev-year":"år",next:"Næste","next-week":"Næste uge","next-month":"Næste måned","next-year":"Næste år","less-than":"Dato interval bør ikke være med end %d dage","more-than":"Dato interval bør ikke være mindre end %d dage","default-more":"Vælg datointerval længere end %d dage","default-single":"Vælg dato","default-less":"Vælg datointerval mindre end %d dage","default-range":"Vælg datointerval mellem %d og %d dage","default-default":"Vælg datointerval",time:"tid",hour:"time",minute:"minut"},fi:{selected:"Valittu:",day:"Päivä",days:"Päivää",apply:"Sulje","week-1":"ma","week-2":"ti","week-3":"ke","week-4":"to","week-5":"pe","week-6":"la","week-7":"su","week-number":"V","month-name":["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],shortcuts:"Pikavalinnat","custom-values":"Mukautetut Arvot",past:"Menneet",following:"Tulevat",previous:"Edellinen","prev-week":"Viikko","prev-month":"Kuukausi","prev-year":"Vuosi",next:"Seuraava","next-week":"Viikko","next-month":"Kuukausi","next-year":"Vuosi","less-than":"Aikajakson tulisi olla vähemmän kuin %d päivää","more-than":"Aikajakson ei tulisi olla vähempää kuin %d päivää","default-more":"Valitse pidempi aikajakso kuin %d päivää","default-single":"Valitse päivä","default-less":"Valitse lyhyempi aikajakso kuin %d päivää","default-range":"Valitse aikajakso %d ja %d päivän väliltä","default-default":"Valitse aikajakso",time:"Aika",hour:"Tunti",minute:"Minuutti"},cat:{selected:"Seleccionats:",day:"Dia",days:"Dies",apply:"Tanca","week-1":"Dl","week-2":"Dm","week-3":"Dc","week-4":"Dj","week-5":"Dv","week-6":"Ds","week-7":"Dg","week-number":"S","month-name":["gener","febrer","març","abril","maig","juny","juliol","agost","setembre","octubre","novembre","desembre"],shortcuts:"Dreçeres","custom-values":"Valors personalitzats",past:"Passat",following:"Futur",previous:"Anterior","prev-week":"Setmana","prev-month":"Mes","prev-year":"Any",next:"Següent","next-week":"Setmana","next-month":"Mes","next-year":"Any","less-than":"El període no hauria de ser de més de %d dies","more-than":"El període no hauria de ser de menys de %d dies","default-more":"Perfavor selecciona un període més gran de %d dies","default-single":"Perfavor selecciona una data","default-less":"Perfavor selecciona un període de menys de %d dies","default-range":"Perfavor selecciona un període d'entre %d i %d dies","default-default":"Perfavor selecciona un període",time:"Temps",hour:"Hora",minute:"Minut"}},e.fn.dateRangePicker=function(a){function n(t,a){return a.contains(t.target)||t.target==a||void 0!=a.childNodes&&e.inArray(t.target,a.childNodes)>=0}function r(){if(!a.inline){var t=e(le).offset();if("relative"==e(a.container).css("position")){var n=e(a.container).offset(),r=Math.max(0,t.left+se.outerWidth()-e("body").width()+16);se.css({top:t.top-n.top+e(le).outerHeight()+4,left:t.left-n.left-r})}else t.left<460?se.css({top:t.top+e(le).outerHeight()+parseInt(e("body").css("border-top")||0,10),left:t.left}):se.css({top:t.top+e(le).outerHeight()+parseInt(e("body").css("border-top")||0,10),left:t.left+e(le).width()-se.width()-16})}}function s(t){F(),o(),a.customOpenAnimation?a.customOpenAnimation.call(se.get(0),function(){e(le).trigger("datepicker-opened",{relatedTarget:se})}):se.slideDown(t,function(){e(le).trigger("datepicker-opened",{relatedTarget:se})}),e(le).trigger("datepicker-open",{relatedTarget:se}),B(),d(),r()}function o(){var e=a.getValue.call(ue),n=e?e.split(a.separator):"";if(n&&(1==n.length&&a.singleDate||n.length>=2)){var r=a.format;r.match(/Do/)&&(r=r.replace(/Do/,"D"),n[0]=n[0].replace(/(\d+)(th|nd|st)/,"$1"),n.length>=2&&(n[1]=n[1].replace(/(\d+)(th|nd|st)/,"$1"))),de=!1,n.length>=2?C(i(n[0],r,t.locale(a.language)),i(n[1],r,t.locale(a.language))):1==n.length&&a.singleDate&&O(i(n[0],r,t.locale(a.language))),de=!0}}function i(e,a,n){return t(e,a,n).isValid()?t(e,a,n).toDate():t().toDate()}function d(){var e=se.find(".gap").css("margin-left");e&&(e=parseInt(e));var t=se.find(".month1").width(),a=se.find(".gap").width()+(e?2*e:0),n=se.find(".month2").width();se.find(".month-wrapper").width(t+a+n)}function l(e,a){se.find("."+e+" input[type=range].hour-range").val(t(a).hours()),se.find("."+e+" input[type=range].minute-range").val(t(a).minutes()),h(e,t(a).format("HH"),t(a).format("mm"))}function u(e,n){a[e]=parseInt(t(parseInt(n)).startOf("day").add(t(a[e+"Time"]).format("HH"),"h").add(t(a[e+"Time"]).format("mm"),"m").valueOf())}function m(){l("time1",a.start),l("time2",a.end)}function h(e,n,r){function s(e,t){var s=t.format("HH"),o=t.format("mm");a[e]=t.startOf("day").add(n||s,"h").add(r||o,"m").valueOf()}switch(n&&se.find("."+e+" .hour-val").text(n),r&&se.find("."+e+" .minute-val").text(r),e){case"time1":a.start&&s("start",t(a.start)),s("startTime",t(a.startTime||t().valueOf()));break;case"time2":a.end&&s("end",t(a.end)),s("endTime",t(a.endTime||t().valueOf()))}x(),M(),T()}function c(e){var n=e;return"week-range"===a.batchMode?n="monday"===a.startOfWeek?t(parseInt(e)).startOf("isoweek").valueOf():t(parseInt(e)).startOf("week").valueOf():"month-range"===a.batchMode&&(n=t(parseInt(e)).startOf("month").valueOf()),n}function p(e){var n=e;return"week-range"===a.batchMode?n="monday"===a.startOfWeek?t(parseInt(e)).endOf("isoweek").valueOf():t(parseInt(e)).endOf("week").valueOf():"month-range"===a.batchMode&&(n=t(parseInt(e)).endOf("month").valueOf()),n}function f(n){if(!n.hasClass("invalid")){var r=n.attr("time");if(n.addClass("checked"),a.singleDate?(a.start=r,a.end=!1):"week"===a.batchMode?"monday"===a.startOfWeek?(a.start=t(parseInt(r)).startOf("isoweek").valueOf(),a.end=t(parseInt(r)).endOf("isoweek").valueOf()):(a.end=t(parseInt(r)).endOf("week").valueOf(),a.start=t(parseInt(r)).startOf("week").valueOf()):"workweek"===a.batchMode?(a.start=t(parseInt(r)).day(1).valueOf(),a.end=t(parseInt(r)).day(5).valueOf()):"weekend"===a.batchMode?(a.start=t(parseInt(r)).day(6).valueOf(),a.end=t(parseInt(r)).day(7).valueOf()):"month"===a.batchMode?(a.start=t(parseInt(r)).startOf("month").valueOf(),a.end=t(parseInt(r)).endOf("month").valueOf()):a.start&&a.end||!a.start&&!a.end?(a.start=c(r),a.end=!1):a.start&&(a.end=p(r),a.time.enabled&&u("end",a.end)),a.time.enabled&&(a.start&&u("start",a.start),a.end&&u("end",a.end)),!a.singleDate&&a.start&&a.end&&a.start>a.end){var s=a.end;a.end=p(a.start),a.start=c(s),a.time.enabled&&a.swapTime&&m()}a.start=parseInt(a.start),a.end=parseInt(a.end),y(),a.start&&!a.end&&(e(le).trigger("datepicker-first-date-selected",{date1:new Date(a.start)}),w(n)),k(r),x(),M(),T(),D()}}function v(e){var n,r,s=parseInt(e.attr("data-start-time"),10);a.startWeek?(se.find(".week-number-selected").removeClass("week-number-selected"),n=new Date(s<a.startWeek?s:a.startWeek),r=new Date(s<a.startWeek?a.startWeek:s),a.startWeek=!1,a.start=t(n).day("monday"==a.startOfWeek?1:0).valueOf(),a.end=t(r).day("monday"==a.startOfWeek?7:6).valueOf()):(a.startWeek=s,e.addClass("week-number-selected"),n=new Date(s),a.start=t(n).day("monday"==a.startOfWeek?1:0).valueOf(),a.end=t(n).day("monday"==a.startOfWeek?7:6).valueOf()),k(),x(),M(),T(),D()}function g(e){if(e=parseInt(e,10),a.startDate&&R(e,a.startDate)<0)return!1;if(a.endDate&&R(e,a.endDate)>0)return!1;if(a.start&&!a.end&&!a.singleDate){if(a.maxDays>0&&S(e,a.start)>a.maxDays)return!1;if(a.minDays>0&&S(e,a.start)<a.minDays)return!1;if(a.selectForward&&e<a.start)return!1;if(a.selectBackward&&e>a.start)return!1;if(a.beforeShowDay&&"function"==typeof a.beforeShowDay){for(var t=!0,n=e;S(n,a.start)>1;){if(!a.beforeShowDay(new Date(n))[0]){t=!1;break}if(Math.abs(n-a.start)<864e5)break;n>a.start&&(n-=864e5),n<a.start&&(n+=864e5)}if(!t)return!1}}return!0}function k(){return se.find(".day.invalid.tmp").removeClass("tmp invalid").addClass("valid"),a.start&&!a.end&&se.find(".day.toMonth.valid").each(function(){g(parseInt(e(this).attr("time"),10))?e(this).addClass("valid tmp").removeClass("invalid"):e(this).addClass("invalid tmp").removeClass("valid")}),!0}function w(t){var n=parseInt(t.attr("time")),r="";if(t.hasClass("has-tooltip")&&t.attr("data-tooltip"))r='<span class="tooltip-content">'+t.attr("data-tooltip")+"</span>";else if(!t.hasClass("invalid"))if(a.singleDate)se.find(".day.hovering").removeClass("hovering"),t.addClass("hovering");else if(se.find(".day").each(function(){var t=parseInt(e(this).attr("time"));a.start,a.end;t==n?e(this).addClass("hovering"):e(this).removeClass("hovering"),a.start&&!a.end&&(a.start<t&&n>=t||a.start>t&&n<=t)?e(this).addClass("hovering"):e(this).removeClass("hovering")}),a.start&&!a.end){var s=S(n,a.start);a.hoveringTooltip&&("function"==typeof a.hoveringTooltip?r=a.hoveringTooltip(s,a.start,n):!0===a.hoveringTooltip&&s>1&&(r=s+" "+te("days")))}if(r){var o=t.offset(),i=se.offset(),d=o.left-i.left,l=o.top-i.top;d+=t.width()/2;var u=se.find(".date-range-length-tip"),m=u.css({visibility:"hidden",display:"none"}).html(r).width(),h=u.height();d-=m/2,l-=h,setTimeout(function(){u.css({left:d,top:l,display:"block",visibility:"visible"})},10)}else se.find(".date-range-length-tip").hide()}function y(){se.find(".day.hovering").removeClass("hovering"),se.find(".date-range-length-tip").hide()}function b(e){var n=e.val(),r=e.attr("name"),s=e.parents("table").hasClass("month1")?"month1":"month2",o="month1"===s?"month2":"month1",i=!!a.startDate&&t(a.startDate),d=!!a.endDate&&t(a.endDate),l=t(a[s])[r](n);i&&l.isSameOrBefore(i)&&(l=i.add("month2"===s?1:0,"month")),d&&l.isSameOrAfter(d)&&(l=d.add(a.singleMonth||"month1"!==s?0:-1,"month")),j(l,s),"month1"===s?(a.stickyMonths||t(l).isSameOrAfter(a[o],"month"))&&j(t(l).add(1,"month"),o):(a.stickyMonths||t(l).isSameOrBefore(a[o],"month"))&&j(t(l).add(-1,"month"),o),B()}function D(){!0===a.singleDate?de&&a.start&&a.autoClose&&L():de&&a.start&&a.end&&a.autoClose&&L()}function x(){var e=Math.ceil((a.end-a.start)/864e5)+1;a.singleDate?a.start&&!a.end?se.find(".drp_top-bar").removeClass("error").addClass("normal"):se.find(".drp_top-bar").removeClass("error").removeClass("normal"):a.maxDays&&e>a.maxDays?(a.start=!1,a.end=!1,se.find(".day").removeClass("checked"),se.find(".drp_top-bar").removeClass("normal").addClass("error").find(".error-top").html(te("less-than").replace("%d",a.maxDays))):a.minDays&&e<a.minDays?(a.start=!1,a.end=!1,se.find(".day").removeClass("checked"),se.find(".drp_top-bar").removeClass("normal").addClass("error").find(".error-top").html(te("more-than").replace("%d",a.minDays))):a.start||a.end?se.find(".drp_top-bar").removeClass("error").addClass("normal"):se.find(".drp_top-bar").removeClass("error").removeClass("normal"),a.singleDate&&a.start&&!a.end||!a.singleDate&&a.start&&a.end?se.find(".apply-btn").removeClass("disabled"):se.find(".apply-btn").addClass("disabled"),a.batchMode&&(a.start&&a.startDate&&R(a.start,a.startDate)<0||a.end&&a.endDate&&R(a.end,a.endDate)>0)&&(a.start=!1,a.end=!1,se.find(".day").removeClass("checked"))}function M(t,n){se.find(".start-day").html("..."),se.find(".end-day").html("..."),se.find(".selected-days").hide(),a.start&&se.find(".start-day").html(N(new Date(parseInt(a.start)))),a.end&&se.find(".end-day").html(N(new Date(parseInt(a.end))));var r;a.start&&a.singleDate?(se.find(".apply-btn").removeClass("disabled"),r=N(new Date(a.start)),a.setValue.call(ue,r,N(new Date(a.start)),N(new Date(a.end))),de&&!n&&e(le).trigger("datepicker-change",{value:r,date1:new Date(a.start)})):a.start&&a.end?(se.find(".selected-days").show().find(".selected-days-num").html(S(a.end,a.start)),se.find(".apply-btn").removeClass("disabled"),r=N(new Date(a.start))+a.separator+N(new Date(a.end)),a.setValue.call(ue,r,N(new Date(a.start)),N(new Date(a.end))),de&&!n&&e(le).trigger("datepicker-change",{value:r,date1:new Date(a.start),date2:new Date(a.end)})):t?se.find(".apply-btn").removeClass("disabled"):se.find(".apply-btn").addClass("disabled")}function S(e,a){return Math.abs(t(e).diff(t(a),"d"))+1}function C(e,t,n){if(e.getTime()>t.getTime()){var r=t;t=e,e=r,r=null}var s=!0;if(a.startDate&&R(e,a.startDate)<0&&(s=!1),a.endDate&&R(t,a.endDate)>0&&(s=!1),!s)return j(a.startDate,"month1"),j(E(a.startDate),"month2"),void B();a.start=e.getTime(),a.end=t.getTime(),a.time.enabled&&(l("time1",e),l("time2",t)),(a.stickyMonths||R(e,t)>0&&0===H(e,t))&&(a.lookBehind?e=q(t):t=E(e)),a.stickyMonths&&!1!==a.endDate&&H(t,a.endDate)>0&&(e=q(e),t=q(t)),a.stickyMonths||0===H(e,t)&&(a.lookBehind?e=q(t):t=E(e)),j(e,"month1"),j(t,"month2"),B(),x(),M(!1,n),D()}function O(e){var t=!0;a.startDate&&R(e,a.startDate)<0&&(t=!1),a.endDate&&R(e,a.endDate)>0&&(t=!1),t?(a.start=e.getTime(),a.time.enabled&&l("time1",e),j(e,"month1"),!0!==a.singleMonth&&j(E(e),"month2"),B(),M(),D()):j(a.startDate,"month1")}function T(){(a.start||a.end)&&(se.find(".day").each(function(){var n=parseInt(e(this).attr("time")),r=a.start,s=a.end;a.time.enabled&&(n=t(n).startOf("day").valueOf(),r=t(r||t().valueOf()).startOf("day").valueOf(),s=t(s||t().valueOf()).startOf("day").valueOf()),a.start&&a.end&&s>=n&&r<=n||a.start&&!a.end&&t(r).format("YYYY-MM-DD")==t(n).format("YYYY-MM-DD")?e(this).addClass("checked"):e(this).removeClass("checked"),a.start&&t(r).format("YYYY-MM-DD")==t(n).format("YYYY-MM-DD")?e(this).addClass("first-date-selected"):e(this).removeClass("first-date-selected"),a.end&&t(s).format("YYYY-MM-DD")==t(n).format("YYYY-MM-DD")?e(this).addClass("last-date-selected"):e(this).removeClass("last-date-selected")}),se.find(".week-number").each(function(){e(this).attr("data-start-time")==a.startWeek&&e(this).addClass("week-number-selected")}))}function j(e,n){var r=z(e=t(e).toDate(),n),s=P(e,n);se.find("."+n+" .month-name").html(r+" "+s),se.find("."+n+" tbody").html(X(e)),a[n]=e,k(),A()}function z(e,n){var r,s=!!a.startDate&&t(a.startDate).add(a.singleMonth||"month2"!==n?0:1,"month"),o=!!a.endDate&&t(a.endDate).add(a.singleMonth||"month1"!==n?0:-1,"month");return e=t(e),!a.monthSelect||s&&o&&s.isSame(o,"month")?'<div class="month-element">'+I(e.get("month"))+"</div>":(r=[s&&e.isSame(s,"year")?s.get("month"):0,e?e.get("month"):11])[0]===r[1]?'<div class="month-element">'+I(e.get("month"))+"</div>":Y("month",V(r,e.get("month"),function(e){return I(e)}))}function P(e,n){e=t(e);var r,s=!!a.startDate&&t(a.startDate).add(a.singleMonth||"month2"!==n?0:1,"month"),o=!!a.endDate&&t(a.endDate).add(a.singleMonth||"month1"!==n?0:-1,"month"),i=e.get("year"),d=a.yearSelect&&"function"==typeof a.yearSelect;return!a.yearSelect||s&&o&&s.isSame(t(o),"year")?'<div class="month-element">'+i+"</div>":(r=d?a.yearSelect(i):a.yearSelect.slice(),r=[s?Math.max(r[0],s.get("year")):Math.min(r[0],i),o?Math.min(r[1],o.get("year")):Math.max(r[1],i)],Y("year",V(r,i)))}function V(e,t,a){var n=[];a=a||function(e){return e};for(var r=e[0];r<=e[1];r++)n.push({value:r,text:a(r),isCurrent:r===t});return n}function Y(e,t){for(var a,n='<div class="select-wrapper"><select class="'+e+'" name="'+e+'">',r=0,s=t.length;r<s;r++)n+='<option value="'+t[r].value+'"'+(t[r].isCurrent?" selected":"")+">",n+=t[r].text,n+="</option>",t[r].isCurrent&&(a=t[r].text);return n+="</select>"+a+"</div>"}function A(){se.find(".day").off("click").click(function(t){f(e(this))}),se.find(".day").off("mouseenter").mouseenter(function(t){w(e(this))}),se.find(".day").off("mouseleave").mouseleave(function(e){se.find(".date-range-length-tip").hide(),a.singleDate&&y()}),se.find(".week-number").off("click").click(function(t){v(e(this))}),se.find(".month").off("change").change(function(t){b(e(this))}),se.find(".year").off("change").change(function(t){b(e(this))})}function W(e,t){se.find("."+t).append($()),l(t,e)}function I(e){return te("month-name")[e]}function N(e){return t(e).format(a.format)}function B(){T();var e=parseInt(t(a.month1).format("YYYYMM")),n=parseInt(t(a.month2).format("YYYYMM")),r=Math.abs(e-n);r>1&&89!=r?se.addClass("has-gap").removeClass("no-gap").find(".gap").css("visibility","visible"):se.removeClass("has-gap").addClass("no-gap").find(".gap").css("visibility","hidden");var s=se.find("table.month1").height(),o=se.find("table.month2").height();se.find(".gap").height(Math.max(s,o)+10)}function L(){if(!a.alwaysOpen){var t=function(){e(le).data("date-picker-opened",!1),e(le).trigger("datepicker-closed",{relatedTarget:se})};a.customCloseAnimation?a.customCloseAnimation.call(se.get(0),t):e(se).slideUp(a.duration,t),e(le).trigger("datepicker-close",{relatedTarget:se})}}function F(){j(a.month1,"month1"),j(a.month2,"month2")}function H(e,a){var n=parseInt(t(e).format("YYYYMM"))-parseInt(t(a).format("YYYYMM"));return n>0?1:0===n?0:-1}function R(e,a){var n=parseInt(t(e).format("YYYYMMDD"))-parseInt(t(a).format("YYYYMMDD"));return n>0?1:0===n?0:-1}function E(e){return t(e).add(1,"months").toDate()}function q(e){return t(e).add(-1,"months").toDate()}function $(){return"<div><span>"+te("Time")+': <span class="hour-val">00</span>:<span class="minute-val">00</span></span></div><div class="hour"><label>'+te("Hour")+': <input type="range" class="hour-range" name="hour" min="0" max="23"></label></div><div class="minute"><label>'+te("Minute")+': <input type="range" class="minute-range" name="minute" min="0" max="59"></label></div>'}function J(){var t='<div class="date-picker-wrapper';a.extraClass&&(t+=" "+a.extraClass+" "),a.singleDate&&(t+=" single-date "),a.showShortcuts||(t+=" no-shortcuts "),a.showTopbar||(t+=" no-topbar "),a.customTopBar&&(t+=" custom-topbar "),t+='">',a.showTopbar&&(t+='<div class="drp_top-bar">',a.customTopBar?("function"==typeof a.customTopBar&&(a.customTopBar=a.customTopBar()),t+='<div class="custom-top">'+a.customTopBar+"</div>"):(t+='<div class="normal-top"><span class="selection-top">'+te("selected")+' </span> <b class="start-day">...</b>',a.singleDate||(t+=' <span class="separator-day">'+a.separator+'</span> <b class="end-day">...</b> <i class="selected-days">(<span class="selected-days-num">3</span> '+te("days")+")</i>"),t+="</div>",t+='<div class="error-top">error</div><div class="default-top">default</div>'),t+='<input type="button" class="apply-btn disabled'+K()+'" value="'+te("apply")+'" />',t+="</div>");var n=a.showWeekNumbers?6:5,r="&lt;";a.customArrowPrevSymbol&&(r=a.customArrowPrevSymbol);var s="&gt;";if(a.customArrowNextSymbol&&(s=a.customArrowNextSymbol),t+='<div class="month-wrapper">   <table class="month1" cellspacing="0" border="0" cellpadding="0">       <thead>           <tr class="caption">               <th>                   <span class="prev">'+r+'                   </span>               </th>               <th colspan="'+n+'" class="month-name">               </th>               <th>'+(a.singleDate||!a.stickyMonths?'<span class="next">'+s+"</span>":"")+'               </th>           </tr>           <tr class="week-name">'+_()+"       </thead>       <tbody></tbody>   </table>",Z()&&(t+='<div class="gap">'+U()+'</div><table class="month2" cellspacing="0" border="0" cellpadding="0">   <thead>   <tr class="caption">       <th>'+(a.stickyMonths?"":'<span class="prev">'+r+"</span>")+'       </th>       <th colspan="'+n+'" class="month-name">       </th>       <th>           <span class="next">'+s+'</span>       </th>   </tr>   <tr class="week-name">'+_()+"   </thead>   <tbody></tbody></table>"),t+='<div class="dp-clearfix"></div><div class="time"><div class="time1"></div>',a.singleDate||(t+='<div class="time2"></div>'),t+='</div><div class="dp-clearfix"></div></div>',t+='<div class="footer">',a.showShortcuts){t+='<div class="shortcuts"><b>'+te("shortcuts")+"</b>";var o=a.shortcuts;if(o){var i;if(o["prev-days"]&&o["prev-days"].length>0){t+='&nbsp;<span class="prev-days">'+te("past");for(d=0;d<o["prev-days"].length;d++)i=o["prev-days"][d],i+=te(o["prev-days"][d]>1?"days":"day"),t+=' <a href="javascript:;" shortcut="day,-'+o["prev-days"][d]+'">'+i+"</a>";t+="</span>"}if(o["next-days"]&&o["next-days"].length>0){t+='&nbsp;<span class="next-days">'+te("following");for(d=0;d<o["next-days"].length;d++)i=o["next-days"][d],i+=te(o["next-days"][d]>1?"days":"day"),t+=' <a href="javascript:;" shortcut="day,'+o["next-days"][d]+'">'+i+"</a>";t+="</span>"}if(o.prev&&o.prev.length>0){t+='&nbsp;<span class="prev-buttons">'+te("previous");for(d=0;d<o.prev.length;d++)i=te("prev-"+o.prev[d]),t+=' <a href="javascript:;" shortcut="prev,'+o.prev[d]+'">'+i+"</a>";t+="</span>"}if(o.next&&o.next.length>0){t+='&nbsp;<span class="next-buttons">'+te("next");for(d=0;d<o.next.length;d++)i=te("next-"+o.next[d]),t+=' <a href="javascript:;" shortcut="next,'+o.next[d]+'">'+i+"</a>";t+="</span>"}}if(a.customShortcuts)for(d=0;d<a.customShortcuts.length;d++)t+='&nbsp;<span class="custom-shortcut"><a href="javascript:;" shortcut="custom">'+a.customShortcuts[d].name+"</a></span>";t+="</div>"}if(a.showCustomValues&&(t+='<div class="customValues"><b>'+(a.customValueLabel||te("custom-values"))+"</b>",a.customValues))for(var d=0;d<a.customValues.length;d++){var l=a.customValues[d];t+='&nbsp;<span class="custom-value"><a href="javascript:;" custom="'+l.value+'">'+l.name+"</a></span>"}return t+="</div></div>",e(t)}function K(){var e="";return!0===a.autoClose&&(e+=" hide"),""!==a.applyBtnClass&&(e+=" "+a.applyBtnClass),e}function _(){var e=a.showWeekNumbers?"<th>"+te("week-number")+"</th>":"";return"monday"==a.startOfWeek?e+"<th>"+te("week-1")+"</th><th>"+te("week-2")+"</th><th>"+te("week-3")+"</th><th>"+te("week-4")+"</th><th>"+te("week-5")+"</th><th>"+te("week-6")+"</th><th>"+te("week-7")+"</th>":e+"<th>"+te("week-7")+"</th><th>"+te("week-1")+"</th><th>"+te("week-2")+"</th><th>"+te("week-3")+"</th><th>"+te("week-4")+"</th><th>"+te("week-5")+"</th><th>"+te("week-6")+"</th>"}function G(e){return e=t(e),!(!a.startDate||!e.endOf("month").isBefore(a.startDate))||!(!a.endDate||!e.startOf("month").isAfter(a.endDate))}function U(){for(var e=['<div class="gap-top-mask"></div><div class="gap-bottom-mask"></div><div class="gap-lines">'],t=0;t<20;t++)e.push('<div class="gap-line"><div class="gap-1"></div><div class="gap-2"></div><div class="gap-3"></div></div>');return e.push("</div>"),e.join("")}function Z(){return!a.singleMonth}function Q(t,a,n){var r=e.extend(!0,{},t);e.each(a,function(e,t){var a=t(n);for(var s in a)r.hasOwnProperty(s)?r[s]+=a[s]:r[s]=a[s]});var s="";for(var o in r)r.hasOwnProperty(o)&&(s+=o+'="'+r[o]+'" ');return s}function X(e){var n=[];e.setDate(1);new Date(e.getTime()-864e5);var r=new Date,s=e.getDay();0===s&&"monday"===a.startOfWeek&&(s=7);var o,i;if(s>0)for(l=s;l>0;l--)i=g((h=new Date(e.getTime()-864e5*l)).getTime()),a.startDate&&R(h,a.startDate)<0&&(i=!1),a.endDate&&R(h,a.endDate)>0&&(i=!1),n.push({date:h,type:"lastMonth",day:h.getDate(),time:h.getTime(),valid:i});for(var d=e.getMonth(),l=0;l<40;l++)i=g((o=t(e).add(l,"days").toDate()).getTime()),a.startDate&&R(o,a.startDate)<0&&(i=!1),a.endDate&&R(o,a.endDate)>0&&(i=!1),n.push({date:o,type:o.getMonth()==d?"toMonth":"nextMonth",day:o.getDate(),time:o.getTime(),valid:i});for(var u=[],m=0;m<6&&"nextMonth"!=n[7*m].type;m++){u.push("<tr>");for(var h=0;h<7;h++){o=n[7*m+("monday"==a.startOfWeek?h+1:h)];var c=t(o.time).format("L")==t(r).format("L");if(o.extraClass="",o.tooltip="",o.valid&&a.beforeShowDay&&"function"==typeof a.beforeShowDay){var p=a.beforeShowDay(t(o.time).toDate());o.valid=p[0],o.extraClass=p[1]||"",o.tooltip=p[2]||"",""!==o.tooltip&&(o.extraClass+=" has-tooltip ")}var f={time:o.time,"data-tooltip":o.tooltip,class:"day "+o.type+" "+o.extraClass+" "+(o.valid?"valid":"invalid")+" "+(c?"real-today":"")};0===h&&a.showWeekNumbers&&u.push('<td><div class="week-number" data-start-time="'+o.time+'">'+a.getWeekNumber(o.date)+"</div></td>"),u.push("<td "+Q({},a.dayTdAttrs,o)+"><div "+Q(f,a.dayDivAttrs,o)+">"+ee(o.time,o.day)+"</div></td>")}u.push("</tr>")}return u.join("")}function ee(e,t){return a.showDateFilter&&"function"==typeof a.showDateFilter?a.showDateFilter(e,t):t}function te(t){var a=t.toLowerCase(),n=t in ie?ie[t]:a in ie?ie[a]:null,r=e.dateRangePickerLanguages.default;return null==n&&(n=t in r?r[t]:a in r?r[a]:""),n}function ae(){var e=a.defaultTime?a.defaultTime:new Date;return a.lookBehind?(a.startDate&&H(e,a.startDate)<0&&(e=E(t(a.startDate).toDate())),a.endDate&&H(e,a.endDate)>0&&(e=t(a.endDate).toDate())):(a.startDate&&H(e,a.startDate)<0&&(e=t(a.startDate).toDate()),a.endDate&&H(E(e),a.endDate)>0&&(e=q(t(a.endDate).toDate()))),a.singleDate&&(a.startDate&&H(e,a.startDate)<0&&(e=t(a.startDate).toDate()),a.endDate&&H(e,a.endDate)>0&&(e=t(a.endDate).toDate())),e}function ne(e){e||(e=ae()),a.lookBehind?(j(q(e),"month1"),j(e,"month2")):(j(e,"month1"),j(E(e),"month2")),a.singleDate&&j(e,"month1"),T(),B()}function re(e){n(e,le[0])||se.is(":visible")&&L()}a||(a={}),(a=e.extend(!0,{autoClose:!1,format:"YYYY-MM-DD",separator:" to ",language:"auto",startOfWeek:"sunday",getValue:function(){return e(this).val()},setValue:function(t){e(this).attr("readonly")||e(this).is(":disabled")||t==e(this).val()||e(this).val(t)},startDate:!1,endDate:!1,time:{enabled:!1},minDays:0,maxDays:0,showShortcuts:!1,shortcuts:{},customShortcuts:[],inline:!1,container:"body",alwaysOpen:!1,singleDate:!1,lookBehind:!1,batchMode:!1,duration:200,stickyMonths:!1,dayDivAttrs:[],dayTdAttrs:[],selectForward:!1,selectBackward:!1,applyBtnClass:"",singleMonth:"auto",hoveringTooltip:function(e,t,a){return e>1?e+" "+te("days"):""},showTopbar:!0,swapTime:!1,showWeekNumbers:!1,getWeekNumber:function(e){return t(e).format("w")},customOpenAnimation:null,customCloseAnimation:null,customArrowPrevSymbol:null,customArrowNextSymbol:null,monthSelect:!1,yearSelect:!1},a)).start=!1,a.end=!1,a.startWeek=!1,a.isTouchDevice="ontouchstart"in window||navigator.msMaxTouchPoints,a.isTouchDevice&&(a.hoveringTooltip=!1),"auto"==a.singleMonth&&(a.singleMonth=e(window).width()<480),a.singleMonth&&(a.stickyMonths=!1),a.showTopbar||(a.autoClose=!0),a.startDate&&"string"==typeof a.startDate&&(a.startDate=t(a.startDate,a.format).toDate()),a.endDate&&"string"==typeof a.endDate&&(a.endDate=t(a.endDate,a.format).toDate()),a.yearSelect&&"boolean"==typeof a.yearSelect&&(a.yearSelect=function(e){return[e-5,e+5]});var se,oe,ie=function(){if("auto"==a.language){var t=navigator.language?navigator.language:navigator.browserLanguage;return t&&(t=t.toLowerCase())in e.dateRangePickerLanguages?e.dateRangePickerLanguages[t]:e.dateRangePickerLanguages.default}return a.language&&a.language in e.dateRangePickerLanguages?e.dateRangePickerLanguages[a.language]:e.dateRangePickerLanguages.default}(),de=!1,le=this,ue=e(le).get(0);return e(this).off(".datepicker").on("click.datepicker",function(e){se.is(":visible")||s(a.duration)}).on("change.datepicker",function(e){o()}).on("keyup.datepicker",function(){try{clearTimeout(oe)}catch(e){}oe=setTimeout(function(){o()},2e3)}),function(){function n(t){var n=e(t).parents("table").hasClass("month2"),r=n?a.month2:a.month1;r=E(r),!a.singleMonth&&!a.singleDate&&!n&&H(r,a.month2)>=0||G(r)||(j(r,n?"month2":"month1"),B())}function s(e){var t=E(a.month1),n=E(a.month2);G(n)||!a.singleDate&&H(t,n)>=0||(j(t,"month1"),j(n,"month2"),T())}function o(t){var n=e(t).parents("table").hasClass("month2"),r=n?a.month2:a.month1;r=q(r),n&&H(r,a.month1)<=0||G(r)||(j(r,n?"month2":"month1"),B())}function i(e){var t=q(a.month1),n=q(a.month2);G(t)||!a.singleDate&&H(n,t)<=0||(j(n,"month2"),j(t,"month1"),T())}var l=this;if(e(this).data("date-picker-opened"))L();else{e(this).data("date-picker-opened",!0),(se=J().hide()).append('<div class="date-range-length-tip"></div>'),e(a.container).append(se),a.inline?se.addClass("inline-wrapper"):r(),a.alwaysOpen&&se.find(".apply-btn").hide();var u=ae();if(ne(u),a.time.enabled)if(a.startDate&&a.endDate||a.start&&a.end)W(t(a.start||a.startDate).toDate(),"time1"),W(t(a.end||a.endDate).toDate(),"time2");else{var m=a.defaultEndTime?a.defaultEndTime:u;W(u,"time1"),W(m,"time2")}var c="";c=te(a.singleDate?"default-single":a.minDays&&a.maxDays?"default-range":a.minDays?"default-more":a.maxDays?"default-less":"default-default"),se.find(".default-top").html(c.replace(/\%d/,a.minDays).replace(/\%d/,a.maxDays)),a.singleMonth?se.addClass("single-month"):se.addClass("two-months"),setTimeout(function(){d(),de=!0},0),se.click(function(e){e.stopPropagation()}),e(document).on("click.datepicker",re),se.find(".next").click(function(){a.stickyMonths?s():n(this)}),se.find(".prev").click(function(){a.stickyMonths?i():o(this)}),se.attr("unselectable","on").css("user-select","none").on("selectstart",function(e){return e.preventDefault(),!1}),se.find(".apply-btn").click(function(){L();var t=N(new Date(a.start))+a.separator+N(new Date(a.end));e(l).trigger("datepicker-apply",{value:t,date1:new Date(a.start),date2:new Date(a.end)})}),se.find("[custom]").click(function(){var t=e(this).attr("custom");a.start=!1,a.end=!1,se.find(".day.checked").removeClass("checked"),a.setValue.call(ue,t),x(),M(!0),T(),a.autoClose&&L()}),se.find("[shortcut]").click(function(){var t,n=e(this).attr("shortcut"),r=new Date,s=!1;if(-1!=n.indexOf("day")){var o=parseInt(n.split(",",2)[1],10);s=new Date((new Date).getTime()+864e5*o),r=new Date(r.getTime()+864e5*(o>0?1:-1))}else if(-1!=n.indexOf("week")){var i;for(i=1==(t=-1!=n.indexOf("prev,")?-1:1)?"monday"==a.startOfWeek?1:0:"monday"==a.startOfWeek?0:6,r=new Date(r.getTime()-864e5);r.getDay()!=i;)r=new Date(r.getTime()+864e5*t);s=new Date(r.getTime()+864e5*t*6)}else if(-1!=n.indexOf("month"))(s=1==(t=-1!=n.indexOf("prev,")?-1:1)?E(r):q(r)).setDate(1),(r=E(s)).setDate(1),r=new Date(r.getTime()-864e5);else if(-1!=n.indexOf("year"))t=-1!=n.indexOf("prev,")?-1:1,(s=new Date).setFullYear(r.getFullYear()+t),s.setMonth(0),s.setDate(1),r.setFullYear(r.getFullYear()+t),r.setMonth(11),r.setDate(31);else if("custom"==n){var d=e(this).html();if(a.customShortcuts&&a.customShortcuts.length>0)for(var l=0;l<a.customShortcuts.length;l++){var u=a.customShortcuts[l];if(u.name==d){var m=[];if((m=u.dates.call())&&2==m.length&&(s=m[0],r=m[1]),m&&1==m.length){var h=m[0];j(h,"month1"),j(E(h),"month2"),B()}break}}}s&&r&&(C(s,r),x())}),se.find(".time1 input[type=range]").on("change touchmove",function(t){var a=t.target;h("time1","hour"==a.name?e(a).val().replace(/^(\d{1})$/,"0$1"):void 0,"minute"==a.name?e(a).val().replace(/^(\d{1})$/,"0$1"):void 0)}),se.find(".time2 input[type=range]").on("change touchmove",function(t){var a=t.target;h("time2","hour"==a.name?e(a).val().replace(/^(\d{1})$/,"0$1"):void 0,"minute"==a.name?e(a).val().replace(/^(\d{1})$/,"0$1"):void 0)})}}.call(this),a.alwaysOpen&&s(0),e(this).data("dateRangePicker",{setStart:function(e){return"string"==typeof e&&(e=t(e,a.format).toDate()),a.end=!1,O(e),this},setEnd:function(e,n){var r=new Date;return r.setTime(a.start),"string"==typeof e&&(e=t(e,a.format).toDate()),C(r,e,n),this},setDateRange:function(e,n,r){"string"==typeof e&&"string"==typeof n&&(e=t(e,a.format).toDate(),n=t(n,a.format).toDate()),C(e,n,r)},clear:function(){a.start=!1,a.end=!1,se.find(".day.checked").removeClass("checked"),se.find(".day.last-date-selected").removeClass("last-date-selected"),se.find(".day.first-date-selected").removeClass("first-date-selected"),a.setValue.call(ue,""),x(),M(),T()},close:L,open:s,redraw:F,getDatePicker:function(){return se},resetMonthsView:ne,destroy:function(){e(le).off(".datepicker"),e(le).data("dateRangePicker",""),e(le).data("date-picker-opened",null),se.remove(),e(window).off("resize.datepicker",r),e(document).off("click.datepicker",re)}}),e(window).on("resize.datepicker",r),this}});

         $("a[href^=http]").each(function(){
            var excludes = [
               'sonne-frankenberg.de'
            ];
            for(i=0; i<excludes.length; i++) {
               if(this.href.indexOf(excludes[i]) != -1) {
                  return true; // continue each() with next link
               }
            }

            if(this.href.indexOf(location.hostname) == -1) {

                 // attach a do-nothing event handler to ensure we can 'trigger' a click on this link
                 $(this).click(function() { return true; });

                 $(this).attr({
                     target: "_blank"
                 });

                 $(this).click(); // trigger it
            }
         });


        //Blog Landing pages
        if ($('body.post-template-default').length > 0) {

          /* Image Lighbox */

          // $("[data-fancybox]").fancybox({
          // });

          $().fancybox({
            selector : '[data-fancybox="image"]',
            loop     : true
          });

          $.fancybox.defaults.hash = false;

          $('.blog-slider').bxSlider({
            infiniteLoop: true,
            auto: true,
            options: 4000,
            mode: 'fade',
            speed: 1000
          });

          $('#single_image img').each(function(){
              $(this).addClass(this.width > this.height ? 'landscape' : 'portrait');
          });
        }




        $('.teaser-wrapper .teaser-close').click(function(){
          $('.teaser-wrapper').fadeOut( 1000 );
        });
        $('.eyecatcher-walkemuehle .teaser-close').click(function(){
          $('.eyecatcher-walkemuehle').fadeOut( 1000 );
        });

        // Opening hours problem
        if ($(window).width() < 768) {
          $('.carousel-hotel-wrapper').each(function() {
            if(!$('.carousel-hotel-wrapper a').hasClass('carousel-button')) {
              $(this).siblings( '.working-hours-wrapper' ).css({
                bottom: '150px'
              });
            }
          });
        }


        // Chrome Datepicker problem
        //$('input[type="date"]').live('click', function(e) {e.preventDefault();}).datepicker();

        $(".wpcf7-date[value='']").datepicker().attr('type','text');
        //$('input[type="date"]').datepicker().attr('type','text');

        // dateFormat

        var dateFormat = $( ".wpcf7-date" ).datepicker( "option", "dateFormat" );
        $( ".wpcf7-date" ).datepicker( "option", "dateFormat", "yy-mm-dd" );


        // Ansprechpartner2
        $('.ansprechpartner-hover-wrapper').hover(function() {
          $(this).find('.visible-text').toggleClass('ansprechpartner-upper');
          $(this).find('.invisible-text').toggleClass('ansprechpartner-lower');
          $(this).find('.text-wrapper').toggleClass('ansprechpartner-text-wrapper');
          $(this).find('.ansprechpartner-first-black-bg').toggleClass('ansprechpartner-first-black-bg-full');
        });


        // If There is no price remove "ab"
        if ($('.arrangement-price').is(':empty')) {
            $('.arrangement-ab').hide();
        }

        //Retina
        // $(document).ready(function(){
        //   if (window.devicePixelRatio > 1) {
        //     var lowresImages = $('img');
        //     images.each(function(i) {
        //       var lowres = $(this).attr('src');
        //       var highres = lowres.replace(".", "@2x.");
        //       $(this).attr('src', highres);
        //     });
        //   }
        // });


        // If the image is portrait or ladscape in the list
        $('.imagetag').each(function() {
          var ImgWidth = $(this).children('img').attr('width');
          var ImgHeight = $(this).children('img').attr('height');
          var contRatio = 213/157;
          var imgRatio = parseInt(ImgWidth)/parseInt(ImgHeight);

          if (contRatio < imgRatio) {
            $(this).children('img').css({
              height: '157px',
              width: 'auto'
            });
          } else {
            $(this).children('img').css({
              height: 'auto',
              width: '213px'
            });
          }
        });


        // If Ansprechpartner has no image
        if ($(window).width() > 767) {
          $(function(){
            if ($('.image-holder').find('img').length) {
              $('.ansprechpartner-wrapper').css({
                position: 'relative'
              });
            } else {
              $('.ansprechpartner-wrapper').css({
                paddingLeft: '0',
                textAlign: 'center'
              });
              $('.ansprechpartner-wrapper').parent().css({
                float: 'left',
                position: 'relative',
                left: '-140px'
              });
            }
          });
        } else {
          $(function(){
            if ($('.image-holder').find('img').length) {
              $('.ansprechpartner-wrapper').css({
                position: 'relative'
              });
            } else {
              $('.ansprechpartner-wrapper').css({
                paddingLeft: '0',
                textAlign: 'center'
              });
              $('.ansprechpartner-wrapper').parent().css({
                float: 'none',
                position: 'relative',
                left: '0px'
              });
            }
          });
        }


        // SLOWES DOWN PAGE JUMP
        $('.scrollen-sie').click(function(){
            $('html, body').animate({
                scrollTop: $( $(this).attr('href') ).offset().top +(-85)
            }, 1000);
            return false;
        });

        $('.carousel-button').click(function(){
            $('html, body').animate({
                scrollTop: $( $(this).attr('href') ).offset().top +(-120)
            }, 1000);
            return false;
        });



        // LIMIT THE TEXT LENGTH ON THE CAROUSEL
        if ($(window).width() > 1520) {
          $("p.content").each(function(i){
            len=$(this).text().length;
            if (len>250) {
              $(this).text($(this).text().substr(0,250)+'...');
            }
          });
        } else if ($(window).width() > 1200) {
          $("p.content").each(function(i){
            len=$(this).text().length;
            if (len>200) {
              $(this).text($(this).text().substr(0,200)+'...');
            }
          });
        } else if ($(window).width() > 1000) {
          $("p.content").each(function(i){
            len=$(this).text().length;
            if (len>400) {
              $(this).text($(this).text().substr(0,400)+'...');
            }
          });
        } else if ($(window).width() > 768) {
          $("p.content").each(function(i){
            len=$(this).text().length;
            if (len>200) {
              $(this).text($(this).text().substr(0,200)+'...');
            }
          });
        } else if ($(window).width() > 1) {
          $("p.content").each(function(i){
            len=$(this).text().length;
            if (len>350) {
              $(this).text($(this).text().substr(0,350)+'...');
            }
          });
        } else {
            $("p.content").each(function(i){
            len=$(this).text().length;
            if (len>350) {
              $(this).text($(this).text().substr(0,350)+'...');
            }
          });
        }


        // LIMIT THE TEXT LENGTH ON HOTEL TEASER
        if ($(window).width() > 1200) {
          $(".selectable-content").each(function(i){
            len=$(this).text().length;
            if (len>230) {
              $(this).text($(this).text().substr(0,230)+'...');
            }
          });
        }  else if ($(window).width() > 768) {
          $(".selectable-content").each(function(i){
            len=$(this).text().length;
            if (len>450) {
              $(this).text($(this).text().substr(0,450)+'...');
            }
          });
        } else if ($(window).width() > 1) {
          $(".selectable-content").each(function(i){
            len=$(this).text().length;
            if (len>200) {
              $(this).text($(this).text().substr(0,200)+'...');
            }
          });
        } else {
            $(".selectable-content").each(function(i){
            len=$(this).text().length;
            if (len>300) {
              $(this).text($(this).text().substr(0,300)+'...');
            }
          });
        }


        // LIMIT THE TEXT LENGTH ON LISTS
        $("a.title").each(function(i){
          len=$(this).text().length;
          if (len>20) {
            $(this).text($(this).text().substr(0,20)+'...');
          }
        });

        $("span.date").each(function(i){
          len=$(this).text().length;
          if (len>25) {
            $(this).text($(this).text().substr(0,25)+'...');
          }
        });

        $(".description p").each(function(i){
          len=$(this).text().length;
          if (len>115) {
            $(this).text($(this).text().substr(0,115)+'...');
          }
        });

        // List
        function list() {
          var list = $('.list');
          list.each(function() {
            var thisList = $(this);
            var filters = $(this).find('.filters');
            function updateList() {
              var teaser = thisList.find('.teasers .teaser');
              teaser.hide();
              if(filters.find('.filter[data-category="all"]').hasClass('active')) {
                teaser.show();
              } else {
                filters.find('.filter.active').each(function() {
                  teaser.filter('[data-categories~="' + $(this).attr('data-category') + '"]').show();
                });
              }
            }
            filters.each(function() {
              var filter = $(this).find('.filter');
              filter.click(function() {
                filter.filter('[data-category="all"]').removeClass('active');
                $(this).toggleClass('active');
                if(filter.filter('.active').length == 0) {
                  filter.filter('[data-category="all"]').addClass('active');
                } else if($(this).is('[data-category="all"]')) {
                  filter.filter(':not([data-category="all"])').removeClass('active');
                }
                updateList();
              });
            });
          });
          const hash = window.location.hash.substring(1);
          const hashFilter = $('.list .filter[data-category="' + hash + '"]');
          if(hashFilter.length) {
            hashFilter.click();
          }
        }
        list();

        // Teasers
        function teasers() {
          var teasers = $('.list .teasers');
          teasers.each(function() {
            var teaser = $(this).find('.teaser');
            teaser.each(function() {
              $(this).css('min-height', $(this).outerHeight() + 'px');
            });
            if("ontouchstart" in document.documentElement) {
              teaser.one("click", false, function(e) {
                e.preventDefault();

                $(this).addClass('hover');
                $(this).find('.hide-on-hover').stop().slideUp();
                $(this).find('.show-on-hover').stop().slideDown();
              });
            }
            teaser.hover(function() {
              $(this).addClass('hover');
              $(this).find('.hide-on-hover').stop().slideUp();
              $(this).find('.show-on-hover').stop().slideDown();
            }, function() {
              $(this).removeClass('hover');
              $(this).find('.hide-on-hover').stop().slideDown();
              $(this).find('.show-on-hover').stop().slideUp();
            });
          });
        }
        teasers();

        // MOBILE MENU
        $(window).resize(function(){
        	if ($(window).width() <= 768){
            $('.hamburger-wrapper').on('click', function () {
                $('.kontakt-main').stop().slideUp('slow');
                $('#main_menu').slideToggle(500);
                $('.sub-menu-content, .sub-menu-lv3').hide(500);
            });

            // main menu
            /*$('#main_menu a.parent').on('click', function (e) {
                // to ignore the href link on this <a> tag
                e.preventDefault();

                if($(this).hasClass('fmenu')){
                    //alert('3rd level menu');
                    $(this).siblings('.sub-menu-lv3').slideToggle(600);
                }
                else{
                    // if already opened, hide it back
                    if($(this).siblings('.sub-menu-content').css('display') === 'block'){
                        $(this).siblings('.sub-menu-content').slideUp(600);
                    }
                    // if not open yet
                    else{
                        // hide other sub menu
                        $('.sub-menu-content').slideUp(0);
                        $(this).siblings('.sub-menu-content').slideDown(600);
                    }
                }
            });*/
        	}
        });

        $('.partner-nav .parent').click(function() {
          $(this).toggleClass('active');
          $(this).next().slideToggle();
        });

        // Mobile menu list slides up
        $('.menu-mobile').stop().slideUp(0);
        $('.menu-mobile .menu-wrapper .menu-part nav ul li ul').slideUp(0);
        /*$('.menu-mobile .menu-wrapper .menu-part nav ul li a').addClass('mobile-plus');

        $('.menu-mobile .menu-wrapper .menu-part nav ul li').click(function(){
          $('.menu-mobile .menu-wrapper .menu-part nav ul li a:visible').removeClass('mobile-minus');
          $(this).find('a').first().addClass('mobile-minus');
          $('.kontakt-main').slideUp('slow');
          $('.menu-mobile .menu-wrapper .menu-part nav ul li ul:visible').slideUp('normal','swing');
          $(this).find('ul').first().stop().slideToggle('normal','swing');
        });*/

        $('.menu-mobile .menu-wrapper .menu-part nav ul li ul').click(function(){
          $('.menu-mobile').stop().slideUp('slow');
        });

        $('.menu-mobile').click(function(){
          $('.kontakt-main').slideUp('slow');
        });

        $('.mobile-contact').click(function(){
          $('.kontakt-main').stop().slideToggle('slow');
          $('.menu-mobile').stop().slideUp('slow');
          $('.menu-main').slideUp('slow');
          $('.hamburger').removeClass('open');
        });


        // BLOG left-right Post Styling
        $(document).ready(function(){
          $('.blog-wrapper-single:odd').css("color", "red");
        });


        // ISOTOPE for BLOG LISTS
        $(function(){
          var $container = $('#container3'),
              $checkboxes = $('#filters3 input');
          $container.isotope({
            itemSelector: '.itemy3'/*,
            layoutMode: 'cellsByRow',
            cellsByRow: {
              gutter: 15,
              columnWidth: 700,
              rowHeight: 470
            }*/
          });
          $checkboxes.change(function(){
            var filters = [];
            // get checked checkboxes values
            $checkboxes.filter(':checked').each(function(){
              filters.push( this.value );
            });
            filters = filters.join(', ');
            $container.isotope({ filter: filters });
          });
        });

        // ISOTOPE for CPT LISTS
        // $(function(){
        //   var $container = $('#container2'),
        //       $checkboxes = $('#filters2 input');
        //   $container.isotope({
        //     itemSelector: '.itemy',
        //     filter: '.arrangements-2',
        //     layoutMode: 'cellsByColumn',
        //     cellsByColumn: {
        //       gutter: 15,
        //       rowHeight: 390
        //     }
        //   });
        //   $checkboxes.change(function(){
        //     var filters = [];
        //     $checkboxes.filter(':checked').each(function(){
        //       filters.push( this.value );
        //     });
        //     filters = filters.join(', ');
        //     $container.isotope({
        //       filter: filters
        //     });
        //   });
        // });

        $('.mobile-book-room').click(function() {
          $('.quickbooker button[type="submit"]').click();
        });

        //ISOTOPE
        $(function(){
          var $container = $('#container2'),
              $checkboxes = $('#filters2 input');


          if (window.location.pathname === '/arrangements/spa/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Spa',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Spa").checked = true;

        } else if (window.location.pathname === '/en/arrangements/spa-en/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Spa',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Spa").checked = true;

        } else if (window.location.pathname === '/nl/arrangements/spa-nl/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Spa',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Spa").checked = true;

        } else if (window.location.pathname === '/arrangements/feiertage/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Feiertage',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Feiertage").checked = true;

        } else if (window.location.pathname === '/en/arrangements/public-holidays/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.PublicHolidays',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("PublicHolidays").checked = true;

        } else if (window.location.pathname === '/nl/arrangements/feestdagen/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Feestdagen',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Feestdagen").checked = true;

        } else if (window.location.pathname === '/arrangements/kultur/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Kultur',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Kultur").checked = true;

        } else if (window.location.pathname === '/en/arrangements/culture/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Culture',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Culture").checked = true;

        } else if (window.location.pathname === '/nl/arrangements/cultuur/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Cultuur',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Cultuur").checked = true;

        } else if (window.location.pathname === '/arrangements/aktiv/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Aktiv',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Aktiv").checked = true;

        } else if (window.location.pathname === '/en/arrangements/active/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Active',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Active").checked = true;

        } else if (window.location.pathname === '/nl/arrangements/actief/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Actief',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Actief").checked = true;

        } else if (window.location.pathname === '/arrangements/kulinarik/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Kulinarik',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Kulinarik").checked = true;

        } else if (window.location.pathname === '/en/arrangements/culinary/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Culinary',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Culinary").checked = true;

        } else if (window.location.pathname === '/nl/arrangements/culinair/') {
          $container.isotope({
            itemSelector: '.itemy',
            filter: '.Culinair',
            layoutMode: 'cellsByRow',
            cellsByColumn: {
              gutter: 15,
              rowHeight: 390
            }
          });
          document.getElementById("Culinair").checked = true;

// EVENTS
          } else if (window.location.pathname === '/events/spa-specials/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.SpaSpecials',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("SpaSpecials").checked = true;

          } else if (window.location.pathname === '/en/events/spa-specials-en/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.Spaspecials',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("Spaspecials").checked = true;

          } else if (window.location.pathname === '/nl/events/spa-specials-nl/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.SpaSpecials',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("SpaSpecials").checked = true;

          } else if (window.location.pathname === '/events/kochkurse/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.Kochkurse',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("Kochkurse").checked = true;

          } else if (window.location.pathname === '/en/events/cookery-course/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.Cookerycourse',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("Cookerycourse").checked = true;

          } else if (window.location.pathname === '/nl/events/kookcursus/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.Kookcursus',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("Kookcursus").checked = true;

          } else if (window.location.pathname === '/events/highlights/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.Highlights',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("Highlights").checked = true;

          } else if (window.location.pathname === '/en/events/highlights-en/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.Highlights',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("Highlights").checked = true;

          } else if (window.location.pathname === '/nl/events/highlights-nl/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.Highlights',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("Highlights").checked = true;

          } else if (window.location.pathname === '/events/kulinarik/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.Kulinarik',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("Kulinarik").checked = true;

          } else if (window.location.pathname === '/en/events/culinary/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.Culinary',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("Culinary").checked = true;

          } else if (window.location.pathname === '/nl/events/culinair/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.Culinair',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("Culinair").checked = true;

          } else if (window.location.pathname === '/events/philipp-soldan-kochclub/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.PhilippSoldanKochclub',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("PhilippSoldanKochclub").checked = true;

          } else if (window.location.pathname === '/en/events/cooking-club/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.PhilippSoldancookingclub',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("PhilippSoldancookingclub").checked = true;

          } else if (window.location.pathname === '/nl/events/philipp-soldan-kookclub/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.PhilippSoldanKookclub',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("PhilippSoldanKookclub").checked = true;

          } else if (window.location.pathname === '/events/brunch/') {
            $container.isotope({
              itemSelector: '.itemy',
              filter: '.Brunch',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
            document.getElementById("Brunch").checked = true;

          } else {
            $container.isotope({
              itemSelector: '.itemy',
              layoutMode: 'cellsByRow',
              cellsByColumn: {
                gutter: 15,
                rowHeight: 390
              }
            });
          }
          $checkboxes.change(function(){
            var filters = [];
            $checkboxes.filter(':checked').each(function(){
              filters.push( this.value );
            });
            filters = filters.join(', ');
            $container.isotope({
              filter: filters
            });
          });
        });


          // Reset all
            //CPT LISTS

          // if(window.location.href.indexOf('arrangements') > -1) {
          //   $('.isotope-reset-cpt').click(function() {
          //     window.location.href = "https://sonne-frankenberg.de/arrangements/";
          //   });
          // } else {
            $('.isotope-reset-cpt').click(function() {
              location.reload();
            });
          // }

          $(function() {
            $('.arrangements-span').click(function (){
              setTimeout( function () {
                if ($("#filters2 input:checkbox:checked").length > 0){
                    $('.isotope-reset-cpt').css({
                      top: '0',
                      backgroundColor: '#ffffff',
                      color: '#aa9e85',
                      border: '1px solid #aa9e85',
                      backgroundImage: 'url("https://sonne-frankenberg.de/wp-content/themes/sonne-frankenberg/dist/images/list-gold-x.png")',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'right'
                    });
                  }
                else
                {
                  $('.isotope-reset-cpt').css({
                    backgroundColor: '#aa9e85',
                    color: '#ffffff'
                  });
                }
              }, 1000);
            });
          });


            //BLOG LISTS
          // $('.isotope-reset-cpt').click(function() {
          //   location.reload();
          // });
          $(function() {
            $('.arrangements-span').click(function (){
              setTimeout( function () {
                if ($("#filters3 input:checkbox:checked").length > 0){
                    $('.isotope-reset-cpt').css({
                      backgroundColor: '#aa9e85',
                      color: '#ffffff'
                    });
                  }
                else
                {
                  $('.isotope-reset-cpt').css({
                    top: '0',
                    backgroundColor: '#ffffff',
                    color: '#aa9e85',
                    border: '1px solid #aa9e85',
                    backgroundImage: 'url("https://sonne-frankenberg.de/wp-content/themes/sonne-frankenberg/dist/images/list-gold-x.png")',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right'
                  });
                }
              }, 50);
            });
          });


            // LEFT & RIGHT LIST FUNCTIONALITY
          if ($(window).width() > 1520) {
            var $numberofarangements2 = Math.ceil(($('.itemy:visible').length - 12)/2);
            var $arangementscounter2 = 0;
            $(function() {
              $('.arrangements-span').click(function (){
                $("#container2").animate({left:'0px'},'slow');
                setTimeout( function(){
                $numberofarangements2 = Math.ceil(($('.itemy:visible').length - 12)/2);
                $arangementscounter2 = 0;
                }, 500);
              });
              // slider BUTTONS
              $(".arangements-right-sidebar-slide2").click(function(){
                if ($arangementscounter2 < $numberofarangements2) {
                  $arangementscounter2 = $arangementscounter2 + 2; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'-=490px'},'slow'); // 245px is the width of one slide
                }
              });
              $(".arangements-left-sidebar-slide2").click(function(){
                if ($arangementscounter2 > 0) {
                  $arangementscounter2 = $arangementscounter2 - 2; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'+=490px'},'slow'); // 245px is the width of one slide
                }
              });
            });
          }  else if ($(window).width() > 1275) {
            var $numberofarangements21275 = Math.ceil(($('.itemy:visible').length - 10)/2);
            var $arangementscounter21275 = 0;
            $(function() {
              $('.arrangements-span').click(function (){
                $("#container2").animate({left:'0px'},'slow');
                setTimeout( function(){
                $numberofarangements21275 = Math.ceil(($('.itemy:visible').length - 10)/2);
                $arangementscounter21275 = 0;
                }, 500);
              });
              // slider BUTTONS
              $(".arangements-right-sidebar-slide2").click(function(){
                if ($arangementscounter21275 < $numberofarangements21275) {
                  $arangementscounter21275 = $arangementscounter21275 + 2; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'-=490px'},'slow'); // 245px is the width of one slide
                }
              });
              $(".arangements-left-sidebar-slide2").click(function(){
                if ($arangementscounter21275 > 0) {
                  $arangementscounter21275 = $arangementscounter21275 - 2; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'+=490px'},'slow'); // 245px is the width of one slide
                }
              });
            });
          } else if ($(window).width() > 1030) {
            var $numberofarangements21030 = Math.ceil(($('.itemy:visible').length - 8)/2);
            var $arangementscounter21030 = 0;
            $(function() {
              $('.arrangements-span').click(function (){
                $("#container2").animate({left:'0px'},'slow');
                setTimeout( function(){
                $numberofarangements21030 = Math.ceil(($('.itemy:visible').length - 8)/2);
                $arangementscounter21030 = 0;
                }, 500);
              });
              // slider BUTTONS
              $(".arangements-right-sidebar-slide2").click(function(){
                if ($arangementscounter21030 < $numberofarangements21030) {
                  $arangementscounter21030 = $arangementscounter21030 + 2; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'-=490px'},'slow'); // 245px is the width of one slide
                }
              });
              $(".arangements-left-sidebar-slide2").click(function(){
                if ($arangementscounter21030 > 0) {
                  $arangementscounter21030 = $arangementscounter21030 - 2; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'+=490px'},'slow'); // 245px is the width of one slide
                }
              });
            });
          } else if ($(window).width() > 785) {
            var $numberofarangements2785 = Math.ceil(($('.itemy:visible').length - 6)/2);
            var $arangementscounter2785 = 0;
            $(function() {
              $('.arrangements-span').click(function (){
                $("#container2").animate({left:'0px'},'slow');
                setTimeout( function(){
                $numberofarangements2785 = Math.ceil(($('.itemy:visible').length - 6)/2);
                $arangementscounter2785 = 0;
                }, 500);
              });
              // slider BUTTONS
              $(".arangements-right-sidebar-slide2").click(function(){
                if ($arangementscounter2785 < $numberofarangements2785) {
                  $arangementscounter2785 = $arangementscounter2785 + 2; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'-=490px'},'slow'); // 245px is the width of one slide
                }
              });
              $(".arangements-left-sidebar-slide2").click(function(){
                if ($arangementscounter2785 > 0) {
                  $arangementscounter2785 = $arangementscounter2785 - 2; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'+=490px'},'slow'); // 245px is the width of one slide
                }
              });
            });
          } else if ($(window).width() > 540) {
            var $numberofarangements2540 = Math.ceil(($('.itemy:visible').length - 4)/2);
            var $arangementscounter2540 = 0;
            $(function() {
              $('.arrangements-span').click(function (){
                $("#container2").animate({left:'0px'},'slow');
                setTimeout( function(){
                $numberofarangements2540 = Math.ceil(($('.itemy:visible').length - 4)/2);
                $arangementscounter2540 = 0;
                }, 500);
              });
              // slider BUTTONS
              $(".arangements-right-sidebar-slide2").click(function(){
                if ($arangementscounter2540 < $numberofarangements2540) {
                  $arangementscounter2540 = $arangementscounter2540 + 2; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'-=490px'},'slow'); // 245px is the width of one slide
                }
              });
              $(".arangements-left-sidebar-slide2").click(function(){
                if ($arangementscounter2540 > 0) {
                  $arangementscounter2540 = $arangementscounter2540 - 2; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'+=490px'},'slow'); // 245px is the width of one slide
                }
              });
            });
          } else if ($(window).width() > 295) {
            var $numberofarangements2295 = Math.ceil(($('.itemy:visible').length - 2)/2);
            var $arangementscounter2295 = 0;
            $(function() {
              $('.arrangements-span').click(function (){
                $("#container2").animate({left:'0px'},'slow');
                setTimeout( function(){
                $numberofarangements2295 = Math.ceil(($('.itemy:visible').length - 2)/2);
                $arangementscounter2295 = 0;
                }, 500);
              });
              // slider BUTTONS
              $(".arangements-right-sidebar-slide2").click(function(){
                if ($arangementscounter2295 < $numberofarangements2295) {
                  $arangementscounter2295 = $arangementscounter2295 + 1; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'-=245px'},'slow'); // 245px is the width of one slide
                }
              });
              $(".arangements-left-sidebar-slide2").click(function(){
                if ($arangementscounter2295 > 0) {
                  $arangementscounter2295 = $arangementscounter2295 - 1; // increment by the x * 245px according to the animate value below
                  $("#container2").animate({left:'+=245px'},'slow'); // 245px is the width of one slide
                }
              });
            });
          }


          // LEFT & RIGHT FOOTER SIDEBAR FUNCTIONALITY
          var $numberofarangements = $('.arangements-wrapper').length;
          //console.log($numberofarangements);

        if ($(window).width() > 1520) {
          var $arangementscounter = 6;
          $(function() {
            // slider BUTTONS
            $(".right-sidebar-slide").click(function(){
              if ($arangementscounter < $numberofarangements) {
                $arangementscounter = $arangementscounter + 1; // increment by the x * 245px according to the animate value below
                $(".arangements-wrapper").animate({left:'-=245px'},'slow'); // 245px is the width of one slide
              }
            });
            $(".left-sidebar-slide").click(function(){
              if ($arangementscounter > 6) {
                $arangementscounter = $arangementscounter - 1; // increment by the x * 245px according to the animate value below
                $(".arangements-wrapper").animate({left:'+=245px'},'slow'); // 245px is the width of one slide
              }
            });
          });
        } else if ($(window).width() > 1275) {
           var $arangementscounter1275 = 5;
           $(function() {
             // slider BUTTONS
             $(".right-sidebar-slide").click(function(){
               if ($arangementscounter1275 < $numberofarangements) {
                 $arangementscounter1275 = $arangementscounter1275 + 1; // increment by the x * 245px according to the animate value below
                 $(".arangements-wrapper").animate({left:'-=245px'},'slow'); // 245px is the width of one slide
               }
             });
             $(".left-sidebar-slide").click(function(){
               if ($arangementscounter1275 > 5) {
                 $arangementscounter1275 = $arangementscounter1275 - 1; // increment by the x * 245px according to the animate value below
                 $(".arangements-wrapper").animate({left:'+=245px'},'slow'); // 245px is the width of one slide
               }
             });
           });
         } else if ($(window).width() > 1030) {
            var $arangementscounter1030 = 4;
            $(function() {
              // slider BUTTONS
              $(".right-sidebar-slide").click(function(){
                if ($arangementscounter1030 < $numberofarangements) {
                  $arangementscounter1030 = $arangementscounter1030 + 1; // increment by the x * 245px according to the animate value below
                  $(".arangements-wrapper").animate({left:'-=245px'},'slow'); // 245px is the width of one slide
                }
              });
              $(".left-sidebar-slide").click(function(){
                if ($arangementscounter1030 > 4) {
                  $arangementscounter1030 = $arangementscounter1030 - 1; // increment by the x * 245px according to the animate value below
                  $(".arangements-wrapper").animate({left:'+=245px'},'slow'); // 245px is the width of one slide
                }
              });
            });
          } else if ($(window).width() > 785) {
             var $arangementscounter785 = 3;
             $(function() {
               // slider BUTTONS
               $(".right-sidebar-slide").click(function(){
                 if ($arangementscounter785 < $numberofarangements) {
                   $arangementscounter785 = $arangementscounter785 + 1; // increment by the x * 245px according to the animate value below
                   $(".arangements-wrapper").animate({left:'-=245px'},'slow'); // 245px is the width of one slide
                 }
               });
               $(".left-sidebar-slide").click(function(){
                 if ($arangementscounter785 > 3) {
                   $arangementscounter785 = $arangementscounter785 - 1; // increment by the x * 245px according to the animate value below
                   $(".arangements-wrapper").animate({left:'+=245px'},'slow'); // 245px is the width of one slide
                 }
               });
             });
           } else if ($(window).width() > 540) {
              var $arangementscounter540 = 2;
              $(function() {
                // slider BUTTONS
                $(".right-sidebar-slide").click(function(){
                  if ($arangementscounter540 < $numberofarangements) {
                    $arangementscounter540 = $arangementscounter540 + 1; // increment by the x * 245px according to the animate value below
                    $(".arangements-wrapper").animate({left:'-=245px'},'slow'); // 245px is the width of one slide
                  }
                });
                $(".left-sidebar-slide").click(function(){
                  if ($arangementscounter540 > 2) {
                    $arangementscounter540 = $arangementscounter540 - 1; // increment by the x * 245px according to the animate value below
                    $(".arangements-wrapper").animate({left:'+=245px'},'slow'); // 245px is the width of one slide
                  }
                });
              });
            } else if ($(window).width() > 295) {
               var $arangementscounter295 = 1;
               $(function() {
                 // slider BUTTONS
                 $(".right-sidebar-slide").click(function(){
                   if ($arangementscounter295 < $numberofarangements) {
                     $arangementscounter295 = $arangementscounter295 + 1; // increment by the x * 245px according to the animate value below
                     $(".arangements-wrapper").animate({left:'-=245px'},'slow'); // 245px is the width of one slide
                   }
                 });
                 $(".left-sidebar-slide").click(function(){
                   if ($arangementscounter295 > 1) {
                     $arangementscounter295 = $arangementscounter295 - 1; // increment by the x * 245px according to the animate value below
                     $(".arangements-wrapper").animate({left:'+=245px'},'slow'); // 245px is the width of one slide
                   }
                 });
               });
             }


        // BREADCRUMBS Fixed on scroll
        if ($(window).width() > 767) {
          $(window).scroll(function() {
            var currentScroll = $(window).scrollTop();
            if (currentScroll >= 355 && (!$('body').is('.home')) ) {
              $('.sonne-breadcrumbs').css({
                position: 'fixed',
                top: '100px',
                left: '0',
                zIndex: '201'
              });
              $('#body').css({
                paddingTop: '105px'
              });
              $('.menu-main').css({
                top: '100px'
              });
              $('.kontakt-main').css({
                top: '100px'
              });
            } else if ($('body').is('.home')) {
              $('.sonne-breadcrumbs').css({
                position: 'static'
              });
              $('.menu-main').css({
                top: '100px'
              });
              $('.kontakt-main').css({
                top: '100px'
              });
              $('#body').css({
                paddingTop: '0'
              });
            } else {
              $('.sonne-breadcrumbs').css({
                position: 'static'
              });
              $('#body').css({
                paddingTop: '100px'
              });
            }
          });
        }

      // IMAGE GALLERY
      $( "<div class='hover-img'></div>" ).appendTo( "li.isotope-item" );
      $('.isotope-item').hover(function(){
        $(this).find('.hover-img').toggleClass('hover-img-seen');
      });


      // MENU On CLICK outside of the menu, close the main menu
      $('.black-menu-background, .menu-item').click(function(){
        $('.black-menu-background').removeClass('black-menu-background-none');
        $('.hamburger').removeClass('open');
        $('.menu-main').slideUp('slow');
        $('.kontakt-main').slideUp('slow');
        $('.arrow-down-mm').stop().slideToggle('slow');
      });


      // MENU TOGGLE Hamburger
      $('.hamburger-wrapper').click(function(){
        if ($(window).width() > 768) {
          $('.hamburger').toggleClass('open');
          $('.menu-main').stop().slideToggle('slow');
            if($('.kontakt-main').is(':hidden')) {
              $('.black-menu-background').toggleClass('black-menu-background-none');
            }
          $('.kontakt-main').slideUp('slow');
          $('.arrow-down-mm').stop().slideToggle('slow');
        } else {
          $('.hamburger').toggleClass('open');
          $('.menu-mobile').stop().slideToggle('slow');
          $('.kontakt-main').slideUp('slow');
          // $('.arrow-down-mm').stop().slideToggle('slow');
          // // $('.arrow-down-mm').css({
          // //   position: 'relative',
          // //   bottom: '-80px',
          // //   right: '-52px',
          // //   zIndex: '2010'
          // // });
        }
      });

      if ($('body').is('.home')) {
        $('.sonne-breadcrumbs').css({
          position: 'static'
        });
        $('.menu-main').css({
          top: '100px'
        });
        $('.kontakt-main').css({
          top: '105px'
        });
        $('#body').css({
          paddingTop: '0'
        });
      }

      // MENU TOGGLE Kontakt
      $('.second-vertical, .first-vertical').click(function(){
        $('.kontakt-main').stop().slideToggle('slow');
        if($('.menu-main').is(':hidden')) {
          $('.black-menu-background').toggleClass('black-menu-background-none');
        }
        $('.menu-main').slideUp('slow');
        $('.hamburger').removeClass('open');
      });


      // SELECTABLE TEASER price is empty
      if ($('.selectable-price').is(':empty')){
        $(".price-wrapper").css("padding-right", "0");
      }

      // Hides scrollen sie on verticall scroll
      var $fpScrollenSie = $('.scrollen-sie');
      $(window).scroll(function(event) {
        if ($(window).scrollTop()>100) {
          $fpScrollenSie.addClass('opacity');
        } else {
          $fpScrollenSie.removeClass('opacity');
        }
      });


      // RESTAURANTS BUTTONS
      if ($(window).width() > 767) {
        $('.single-wrapper1').hover(function() {
          $(".thegreen").toggleClass("big-restaurant");
          $(".logo1").toggleClass("rest-logo-up");
          $(".text1").toggleClass("border-fade");
          $(".restaurant-button1").toggleClass("rest-button-down1");
          $(".border1").toggleClass("border-fade");
          $(".border1a").toggleClass("border-fade");
        });
        $('.single-wrapper2').hover(function() {
          $(".theyellow").toggleClass("big-restaurant");
          $(".logo2").toggleClass("rest-logo-up");
          $(".text2").toggleClass("border-fade");
          $(".restaurant-button2").toggleClass("rest-button-down3");
          $(".border2").toggleClass("border-fade");
          $(".border2a").toggleClass("border-fade");
        });
        $('.single-wrapper3').hover(function() {
          $(".thered").toggleClass("big-restaurant");
          $(".logo3").toggleClass("rest-logo-up");
          $(".text3").toggleClass("border-fade");
          $(".restaurant-button3").toggleClass("rest-button-down3");
          $(".border3").toggleClass("border-fade");
          $(".border3a").toggleClass("border-fade");
        });
      } else {
        $(".thegreen").toggleClass("big-restaurant");
        $(".logo1").toggleClass("rest-logo-up");
        $(".text1").toggleClass("border-fade");
        $(".restaurant-button1").toggleClass("rest-button-down");
        $(".border1").toggleClass("border-fade");
        $(".border1a").toggleClass("border-fade");

        $(".theyellow").toggleClass("big-restaurant");
        $(".logo2").toggleClass("rest-logo-up");
        $(".text2").toggleClass("border-fade");
        $(".restaurant-button2").toggleClass("rest-button-down");
        $(".border2").toggleClass("border-fade");
        $(".border2a").toggleClass("border-fade");

        $(".thered").toggleClass("big-restaurant");
        $(".logo3").toggleClass("rest-logo-up");
        $(".text3").toggleClass("border-fade");
        $(".restaurant-button3").toggleClass("rest-button-down");
        $(".border3").toggleClass("border-fade");
        $(".border3a").toggleClass("border-fade");
      }


      // Adds a class for the enlarge button on ZIMMER CAROUSEL
      $(".vc_left").after("<div class='enlarge'></div>");




      /*
      // Video MODAL

      var url = $("#catVideo").attr('src');

      $("#myModal").on('hide.bs.modal', function(){
          $("#catVideo").attr('src', '');
      });

      $("#myModal").on('show.bs.modal', function(){
          $("#catVideo").attr('src', url);
      });
      */


      if ($('body.page-template-template-google-maps').length > 0  || $('body.page-template-template-indexpage').length > 0) {
        // Google Maps
        function initialize(){
          var directionDisplay;
          var directionsService = new google.maps.DirectionsService();
          var map;
          var home = new google.maps.LatLng(51.0590745, 8.8015491,19);
          directionsDisplay = new google.maps.DirectionsRenderer();
          var myOptions =
          {
            zoom:16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: home,
            styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
          };
          map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
          directionsDisplay.setMap(map);
          directionsDisplay.setPanel(document.getElementById("directions"));

          var myLatLng = new google.maps.LatLng(51.0590745, 8.8015491,19);
            var image = 'https://sonne-frankenberg.de/wp-content/uploads/2016/09/Pin.png';
          var beachMarker = new google.maps.Marker
          ({
              position: myLatLng,
              map: map,
              icon: image
          });
        }

        function calcRoute(){
          var directionDisplay;
          var directionsService = new google.maps.DirectionsService();
          var map;
          var home = new google.maps.LatLng(51.0590745, 8.8015491,19);
          var start1 = document.getElementById("routefrom1").value;
          var start2 = document.getElementById("routefrom2").value;
          var start = start1.concat(start2);

          var request =
          {
            origin:start,
            destination:home,
            travelMode: google.maps.DirectionsTravelMode.DRIVING
          };
          directionsService.route(request, function(response, status){
            if (status === google.maps.DirectionsStatus.OK){
              directionsDisplay.setDirections(response);
            }
          });
        }
        $(window).one('mousemove', function() {
          $.getScript('https://maps.google.com/maps/api/js?key=AIzaSyBAnWu_6rEHcBcMhvT1L0gPYNIvMWzx2Jw&sensor=true').done(function(script, textStatus) {
            initialize();
            $('#routeform').submit(function(e)
            {
              calcRoute();
              return false;
            });
          });
        });
      }


      // Wraps SELECT2 on all select objects
      $('select:not(.no-select2)').select2();


      // Restraurnt Quickbooker
      function restaurantQuickbooker() {
        var restaurantQuickbooker = $('.restaurant-quickbooker');
        restaurantQuickbooker.each(function() {
          var quickbooker = $(this);
          var quickbookerId = quickbooker.attr('data-id');
          var quickbookerPicker = quickbooker.find('.quickbooker-picker');
          var selectRestaurant = quickbooker.find('select[name="restaurant"]');
          var selectPersons = quickbooker.find('select[name="persons"]');
          var selectTime = quickbooker.find('select[name="time"]');

          function openQuickbookerPicker() {
            quickbookerPicker.fadeIn(250);
          }

          function closeQuickbookerPicker() {
            quickbookerPicker.fadeOut(250);
          }

          quickbooker.dateRangePicker({
            language: $('body').attr('data-lang'),
            format: 'DD.MM.YYYY',
            startOfWeek: 'monday',
            inline: true,
            container: '.restaurant-quickbooker[data-id="' + quickbookerId + '"] .quickbooker-datepicker',
            alwaysOpen: true,
            separator: ' - ',
            customArrowPrevSymbol: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.718 15.297"><path d="M962.03,228.521l7.646,7.344-7.646,7.229" transform="translate(970.401 243.457) rotate(180)"/></svg>',
            customArrowNextSymbol: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.718 15.297"><path d="M962.03,228.521l7.646,7.344-7.646,7.229" transform="translate(-961.684 -228.159)"/></svg>',
            hoveringTooltip: false,
            singleMonth: true,
            showTopbar: false,
            singleDate : true,
            setValue: function(s, s1, s2) {
              quickbooker.find('.restaurant-date').html(s1);
              closeQuickbookerPicker()
            },
          });

          quickbooker.find('.li-date').click(function() {
            if(!quickbookerPicker.is(':visible')) {
              openQuickbookerPicker();
            } else {
              closeQuickbookerPicker();
            }
          });

          quickbooker.find('#target').click(function() {
            if(selectRestaurant.length > 0) {
              if(selectRestaurant.val() != '') {
                var openTableWrapper = quickbooker.find('.open-table-wrapper');
                /*openTableWrapper.find('.ot-date-picker .ot-date-label').html('28. Mai 2020');
                openTableWrapper.find('input[name="datepicker"]').attr('data-value', '2020-05-28').val('2020-05-28').change();
                openTableWrapper.find('input[name="submit_datepicker"]').attr('value', '28. Mai 2020').val('28. Mai 2020').change();*/
                if(quickbooker.find('.restaurant-date').html() != 'Datum') {
                  var res = quickbooker.find('.restaurant-date').html().split(".");
                  OT.Common.DatePicker.set($('.ot-date-picker'), res[2] + '-' + res[1] + '-' + res[0]);
                }
                if(selectRestaurant.val() != '') {
                  openTableWrapper.find('.ot-restaurant-picker select').val(selectRestaurant.val()).change();
                }
                if(selectTime.val() != '') {
                  openTableWrapper.find('.ot-time-picker select').val(selectTime.val()).change();
                }
                if(selectPersons.val() != '') {
                  openTableWrapper.find('.ot-party-size-picker select').val(selectPersons.val()).change();
                }
                setTimeout(function() {
                  openTableWrapper.find('.ot-button').trigger('click');
                }, 1);
              }
            } else {
              var openTableWrapper = quickbooker.find('.open-table-wrapper');
              /*openTableWrapper.find('.ot-date-picker .ot-date-label').html('28. Mai 2020');
              openTableWrapper.find('input[name="datepicker"]').attr('data-value', '2020-05-28').val('2020-05-28').change();
              openTableWrapper.find('input[name="submit_datepicker"]').attr('value', '28. Mai 2020').val('28. Mai 2020').change();*/
              //OT.Common.DatePicker.set($('.ot-date-picker'), quickbooker.find('.restaurant-date').html(), 'DD.MM.YYYY');
              if(quickbooker.find('.restaurant-date').html() != 'Datum') {
                var res = quickbooker.find('.restaurant-date').html().split(".");
                OT.Common.DatePicker.set($('.ot-date-picker'), res[2] + '-' + res[1] + '-' + res[0]);
              }
              if(selectTime.val() != '') {
                openTableWrapper.find('.ot-time-picker select').val(selectTime.val()).change();
              }
              if(selectPersons.val() != '') {
                openTableWrapper.find('.ot-party-size-picker select').val(selectPersons.val()).change();
              }
              setTimeout(function() {
                openTableWrapper.find('.ot-button').trigger('click');
              }, 1);
            }
          });
        });
      }
      restaurantQuickbooker();


      // Calls the Datepicker Arrival
        $(".qbdatepicker").datepicker({
          firstDay: 1,
          dateFormat: "dd.mm.yy",
          defaultDate: +1,
          minDate: +1
        });
        $(".qbdatepicker").datepicker('setDate', new Date());


      // Calls the Datepicker Departure
        $(".qbdatepicker2").datepicker({
          firstDay: 1,
          dateFormat: "dd.mm.yy",
          defaultDate: +1,
          minDate: +2
        });
        $(".qbdatepicker2").datepicker('setDate', new Date());


      // Number of nights on the quickbooker
      var NightsMax = 100;
      var NightsMin = 1;
      $(".rooms-plus").click(function(){
        var roomInput = $(".qb-rooms").find("input");
        var numberOfRooms = parseInt(roomInput.val())+1;
          if(numberOfRooms > NightsMax){
            numberOfRooms = NightsMax;
          }
        roomInput.val( numberOfRooms );
      });
      $(".rooms-minus").click(function(){
        var roomInput = $(".qb-rooms").find("input");
        var numberOfRooms = parseInt(roomInput.val())-1;
        if(numberOfRooms < NightsMin){
          numberOfRooms = NightsMin;
       }
      roomInput.val( numberOfRooms );
      });


      // Quickbooker
      function quickbooker() {
        var quickbooker = $('.quickbooker');
        quickbooker.each(function() {
          var quickbooker = $(this);
          var quickbookerId = quickbooker.attr('data-id');
          var quickbookerPicker = quickbooker.find('.quickbooker-picker');
          var quickbookerInputBox = quickbooker.find('.input-box');
          var inputBoxArrival = quickbooker.find('.input-box.arrival');
          var inputBoxDeparture = quickbooker.find('.input-box.departure');
          var inputBoxPersons = quickbooker.find('.input-box.persons');
          var arrival = quickbooker.find('input.arrival');
          var departure = quickbooker.find('input.departure');
          var persons = quickbooker.find('input.persons');

          function openQuickbookerPicker() {
            quickbookerPicker.fadeIn(250);
          }

          function closeQuickbookerPicker() {
            quickbookerPicker.fadeOut(250);
          }

          function setInputBoxArrival(date) {
            inputBoxArrival.find('.day').text(('0' + date.getDate()).slice(-2));
            inputBoxArrival.find('.month').text(date.toLocaleString($('html').attr('lang'), { month: 'long' }));
          }

          function setInputBoxDeparture(date) {
            inputBoxDeparture.find('.day').text(('0' + date.getDate()).slice(-2));
            inputBoxDeparture.find('.month').text(date.toLocaleString($('html').attr('lang'), { month: 'long' }));
          }

          function setInputBoxPersons(number) {
            inputBoxPersons.find('.number').text(number);
          }

          quickbooker.dateRangePicker({
            language: $('body').attr('data-lang'),
            format: 'DD.MM.YYYY',
            startOfWeek: 'monday',
            inline: true,
            container: '.quickbooker[data-id="' + quickbookerId + '"] .quickbooker-datepicker',
            alwaysOpen: true,
            separator: ' - ',
            customArrowPrevSymbol: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.718 15.297"><path d="M962.03,228.521l7.646,7.344-7.646,7.229" transform="translate(970.401 243.457) rotate(180)"/></svg>',
            customArrowNextSymbol: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.718 15.297"><path d="M962.03,228.521l7.646,7.344-7.646,7.229" transform="translate(-961.684 -228.159)"/></svg>',
            getValue: function() {
              if (arrival.val() && departure.val()) {
                return arrival.val() + ' - ' + departure.val();
              } else {
                return '';
              }
            },
            setValue: function(s, s1, s2) {
              arrival.val(s1);
              departure.val(s2);
            },
            beforeShowDay: function(t) {
              t = t.setHours(0, 0, 0, 0);
              var today = new Date().setHours(0, 0, 0, 0);
              var valid = (t >= today);
              var _class = '';
              var _tooltip = '';
              return [valid, _class, _tooltip];
            },
            hoveringTooltip: false,
            singleMonth: true,
            showTopbar: false
          }).bind('datepicker-first-date-selected', function(event, obj) {
            setInputBoxArrival(obj.date1);
          }).bind('datepicker-change', function(event, obj) {
            setInputBoxArrival(obj.date1);
            setInputBoxDeparture(obj.date2);
          });

          quickbookerInputBox.click(function() {
            if(!quickbookerPicker.is(':visible')) {
              openQuickbookerPicker();
            } else {
              closeQuickbookerPicker();
            }
          });

          var quickbookerPersonspickerNumber = quickbooker.find('.quickbooker-personspicker .number');
          quickbookerPersonspickerNumber.click(function() {
            quickbookerPersonspickerNumber.removeClass('selected');
            $(this).addClass('selected');
            persons.val($(this).attr('data-val'));
            setInputBoxPersons($(this).attr('data-val'));
            closeQuickbookerPicker();
          });
        });
      }
      quickbooker();

      // Content Slider
      function contentSlider() {
        var contentSlider = $('.content-slider');
        contentSlider.each(function() {
          var imageSlider = $(this).find('.image-box .slides');
          var contentSlider = $(this).find('.content-box .slides');
          imageSlider.bxSlider({
            infiniteLoop: true,
            mode: 'fade',
            speed: 1000,
            controls: false,
            pager: false
          });
          contentSlider.bxSlider({
            infiniteLoop: true,
            mode: 'fade',
            speed: 1000,
            controls: false,
            pager: false,
            adaptiveHeight: true,
            adaptiveHeightSpeed: 1000
          });
          $(this).find('.slider-arrows .arrow.prev').click(function() {
            imageSlider.goToPrevSlide();
            contentSlider.goToPrevSlide();
          });
          $(this).find('.slider-arrows .arrow.next').click(function() {
            imageSlider.goToPrevSlide();
            contentSlider.goToPrevSlide();
          });
          setTimeout(function() {
            contentSlider.reloadSlider();
            setTimeout(function() {
              contentSlider.reloadSlider();
              setTimeout(function() {
                contentSlider.reloadSlider();
                setTimeout(function() {
                  contentSlider.reloadSlider();
                }, 2000);
              }, 1000);
            }, 500);
          }, 100);
        });
      }
      contentSlider();

      // Restaurant Menu
      function restaurantMenu() {
        var restaurantMenu = $('.restaurant-menu');
        restaurantMenu.each(function() {
          var imageSlider = $(this).find('.image-box .slides');
          var contentSlider = $(this).find('.content-box .slides');
          imageSlider.bxSlider({
            infiniteLoop: true,
            mode: 'fade',
            speed: 1000,
            controls: false,
            pager: false
          });
          contentSlider.bxSlider({
            infiniteLoop: true,
            mode: 'fade',
            speed: 1000,
            controls: false,
            pager: false
          });
          $(this).find('.slider-arrows .arrow.prev').click(function() {
            imageSlider.goToPrevSlide();
            contentSlider.goToPrevSlide();
          });
          $(this).find('.slider-arrows .arrow.next').click(function() {
            imageSlider.goToPrevSlide();
            contentSlider.goToPrevSlide();
          });
        });
      }
      restaurantMenu();

      if($(window).width() >= 1000) {
        $('.vc_images_carousel .vc_carousel-inner .vc_carousel-slideline').addClass('rellax-image');
        $('.content-slider .image-box .slides .image').addClass('rellax-image');
        $('.carousel-hotel-wrapper').each(function() {
          if($(this).find('.text-area .image-title').length == 0) {
            //$(this).addClass('rellax-box');
          }
        });
        //$('.content-slider .content-box').addClass('rellax-box');
        /*if($('.rellax-image').length == 1) {
          var rellax = new Rellax('.rellax-image', {
            speed: 2.5,
            center: true
          });
        }
        if($('.rellax-box').length == 1) {
          var rellax = new Rellax('.rellax-box', {
            speed: -1.5,
            center: true
          });
        }*/
      }

      $(window).resize(function() {
        var vcImagesCarousel = $('.vc_images_carousel');
        vcImagesCarousel.each(function() {
          var thisCarousel = $(this);
          setTimeout(function() {
            var carouselWidth = thisCarousel.width();
            thisCarousel.find('.vc_carousel-slideline').css('width', thisCarousel.find('.vc_item').length * carouselWidth);
          }, 50);
          setTimeout(function() {
            var carouselWidth = thisCarousel.width();
            thisCarousel.find('.vc_carousel-slideline').css('width', thisCarousel.find('.vc_item').length * carouselWidth);
          }, 750);
          setTimeout(function() {
            var carouselWidth = thisCarousel.width();
            thisCarousel.find('.vc_carousel-slideline').css('width', thisCarousel.find('.vc_item').length * carouselWidth);
          }, 1500);
        });
      });

      $('.open-link').click(function(e) {
        e.preventDefault();
        if($(this).attr('data-target') == '_blank') {
          var win = window.open($(this).attr('data-href'), '_blank');
          win.focus();
        } else {
          window.location.href = $(this).attr('data-href');
        }
      });

      $('.corona-popup').each(function() {
        if(Cookies.get('corona-popup') != 'true') {
          $(this).fadeIn(500);
          $(this).find('.close-popup').click(function() {
            $('.corona-popup').fadeOut(500);
            Cookies.set('corona-popup', 'true');
          });
        }
      });

      objectFitImages();

      // $(function () { $("#target").lbuiDirect(
      //   {
      //     connectionid  :  "DE-RES-PHILIPPSOLDAN_293910:77773",
      //     language  :  "de-DE",
      //     popupWindow  :  {
      //       enabled  :  true
      //     }
      //   });
      // });


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        /*$(".third-vertical").on("click", function( e ) {
            $("body, html").animate({
                scrollTop: ($( '#breadcrumbs_p' ).offset().top) - 85
            }, 600);

        });*/

        $(".hamburger-wrapper, .first-vertical").on("click", function( e ) {
            e.preventDefault();
            $("body, html").animate({
                scrollTop: ($( '#breadcrumbs_p' ).offset().top) - 85
            }, 600);

        });

      if ($(window).width() > 767) {
        $('html, body').animate({scrollTop:1},1000);
      }




      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
